export const productsDataBreads = [
  // ソフトカンパーニュ
  {
    id: 7705873023230,
    title: 'ソフトカンパーニュ',
    handle: 'be-0020-001',
    description:
      'ボリューム感のある素朴な味わいの田舎風フランスパンです。しっとりとした食感に焼き上げ、洋食メニューにも合う食卓パンが出来ました。',
    published_at: '2022-06-07T16:16:47+09:00',
    created_at: '2022-06-07T16:16:47+09:00',
    vendor: '食+',
    type: '',
    tags: [
      'all',
      'reckey_HEEeEbHc',
      'reckey_HEEeEbHf',
      'reckey_HEEeEbHi',
      'reckey_HEEeEbHp',
      'reckey_HEEeEbHv',
      'reckey_HEZzHcEb',
      'reckey_HEZzHfEb',
      'reckey_HEZzHiEb',
      'reckey_HEZzHpEb',
      'reckey_HEZzHvEb',
      'reckey_HXXxXtHc',
      'reckey_HXXxXtHf',
      'reckey_HXXxXtHi',
      'reckey_HXXxXtHp',
      'reckey_HXXxXtHv',
      'reckey_HXZzHcXt',
      'reckey_HXZzHfXt',
      'reckey_HXZzHiXt',
      'reckey_HXZzHpXt',
      'reckey_HXZzHvXt',
      'reckey_SEEeEbHc',
      'reckey_SEEeEbHf',
      'reckey_SEEeEbHi',
      'reckey_SEEeEbHpbHp',
      'reckey_SEEeEbHv',
      'reckey_SEZzSaEbHc',
      'reckey_SEZzSaEbHf',
      'reckey_SEZzSaEbHi',
      'reckey_SEZzSaEbHp',
      'reckey_SEZzSaEbHv',
      'reckey_SEZzSlEbHc',
      'reckey_SEZzSlEbHf',
      'reckey_SEZzSlEbHi',
      'reckey_SEZzSlEbHp',
      'reckey_SEZzSlEbHv',
      'reckey_SEZzSoEbHc',
      'reckey_SEZzSoEbHf',
      'reckey_SEZzSoEbHi',
      'reckey_SEZzSoEbHp',
      'reckey_SEZzSoEbHv',
      'reckey_SEZzSwEbHc',
      'reckey_SEZzSwEbHf',
      'reckey_SEZzSwEbHi',
      'reckey_SEZzSwEbHp',
      'reckey_SEZzSwEbHv',
      'reckey_SXXxXtHc',
      'reckey_SXXxXtHf',
      'reckey_SXXxXtHi',
      'reckey_SXXxXtHp',
      'reckey_SXXxXtHv',
      'reckey_SXZzSaXtHc',
      'reckey_SXZzSaXtHf',
      'reckey_SXZzSaXtHi',
      'reckey_SXZzSaXtHp',
      'reckey_SXZzSaXtHv',
      'reckey_SXZzSlXtHc',
      'reckey_SXZzSlXtHf',
      'reckey_SXZzSlXtHi',
      'reckey_SXZzSlXtHp',
      'reckey_SXZzSlXtHv',
      'reckey_SXZzSoXtHc',
      'reckey_SXZzSoXtHf',
      'reckey_SXZzSoXtHi',
      'reckey_SXZzSoXtHp',
      'reckey_SXZzSoXtHv',
      'reckey_SXZzSwXtHc',
      'reckey_SXZzSwXtHf',
      'reckey_SXZzSwXtHi',
      'reckey_SXZzSwXtHp',
      'reckey_SXZzSwXtHv',
      'ベーカリー',
      '料理と一緒に楽しむパン',
    ],
    price: 25000,
    price_min: 25000,
    price_max: 25000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 42893764886782,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7611013',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: 'ソフトカンパーニュ',
        public_title: null,
        options: ['Default Title'],
        price: 25000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: '',
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 23800,
              },
            ],
            price: 23800,
            compare_at_price: 25000,
            per_delivery_price: 23800,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 23800,
              },
            ],
            price: 23800,
            compare_at_price: 25000,
            per_delivery_price: 23800,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 23800,
              },
            ],
            price: 23800,
            compare_at_price: 25000,
            per_delivery_price: 23800,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0020-001_01.png?v=1655179923',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0020-001_02.png?v=1655189453',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0020-001_04.png?v=1655189454',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0020-001_03_a1c04946-7226-431d-8dbd-59c7b7f8128c.png?v=1681143868',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/what_s-plant-based_508c1ca6-f658-499f-9222-b473c1194457.png?v=1681143868',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0020-001_01.png?v=1655179923',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/be-0020-001',
    media: [
      {
        alt: 'ソフトカンパーニュ',
        id: 30068908359934,
        position: 1,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0020-001_01.png?v=1655179923',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0020-001_01.png?v=1655179923',
        width: 1500,
      },
      {
        alt: 'ソフトカンパーニュ_断面',
        id: 30069360099582,
        position: 2,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0020-001_02.png?v=1655189453',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0020-001_02.png?v=1655189453',
        width: 1500,
      },
      {
        alt: 'ソフトカンパーニュ_個包装',
        id: 30069360165118,
        position: 3,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0020-001_04.png?v=1655189454',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0020-001_04.png?v=1655189454',
        width: 1500,
      },
      {
        alt: null,
        id: 32188196192510,
        position: 4,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0020-001_03_a1c04946-7226-431d-8dbd-59c7b7f8128c.png?v=1681143868',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0020-001_03_a1c04946-7226-431d-8dbd-59c7b7f8128c.png?v=1681143868',
        width: 1500,
      },
      {
        alt: null,
        id: 31850993025278,
        position: 5,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/what_s-plant-based_508c1ca6-f658-499f-9222-b473c1194457.png?v=1681143868',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/what_s-plant-based_508c1ca6-f658-499f-9222-b473c1194457.png?v=1681143868',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回お届けプラン', '2週に1回お届けプラン', '4週に1回お届けプラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回お届けプラン',
            description: '週に1回商品をお届けします',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回お届けプラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回お届けプラン',
            description: '2週に1回商品をお届けします',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回お届けプラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回お届けプラン',
            description: '4週に1回商品をお届けします',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回お届けプラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '1個',
      },
      {
        title: '原材料',
        content:
          '小麦粉（国内製造）、小麦全粒粉、砂糖、ショートニング、発酵風味料、イースト、食塩、モルトエキス、アセロラパウダー、（一部に小麦を含む）',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content: 'エネルギー 163kcal、たんぱく質 5.3g、脂質 3.1g、炭水化物 28.4g、食塩相当量 0.8g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: true,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: false,
          },
          {
            title: '乳成分',
            content: false,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: false,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: false,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: false,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: false,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },

      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約φ100㎜×約H52㎜ / 約60g',
      },
      {
        title: 'お召し上がり方法',
        content: '袋のまま室温（約25℃）で約3時間解凍してください。',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上※パッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '',
    allergy_caution: '',
  },
  // くるみブレッド（2個入）
  {
    id: 7705872957694,
    title: 'くるみブレッド（2個入）',
    handle: 'be-0018-001',
    description:
      'くるみと相性の良い全粒粉の小麦を使用して、香り高い歯切れの良い食事パンに仕上げました。全粒粉の香ばしさとクルミの食感が絶妙なハーモニーを奏でます。',
    published_at: '2022-06-07T16:16:46+09:00',
    created_at: '2022-06-07T16:16:46+09:00',
    vendor: '食+',
    type: '',
    tags: [
      'all',
      'reckey_HEHhHv',
      'reckey_HEZzHvEb',
      'reckey_HEZzHvEs',
      'reckey_HXHhHv',
      'reckey_HXZzHvXc',
      'reckey_HXZzHvXh',
      'reckey_HXZzHvXt',
      'reckey_SESsSwHc',
      'reckey_SESsSwHf',
      'reckey_SESsSwHi',
      'reckey_SESsSwHp',
      'reckey_SESsSwHv',
      'reckey_SEZzSwEbHc',
      'reckey_SEZzSwEbHf',
      'reckey_SEZzSwEbHi',
      'reckey_SEZzSwEbHp',
      'reckey_SEZzSwEbHv',
      'reckey_SEZzSwEsHc',
      'reckey_SEZzSwEsHf',
      'reckey_SEZzSwEsHi',
      'reckey_SEZzSwEsHp',
      'reckey_SEZzSwEsHv',
      'reckey_SXSsSwHc',
      'reckey_SXSsSwHf',
      'reckey_SXSsSwHi',
      'reckey_SXSsSwHp',
      'reckey_SXSsSwHv',
      'reckey_SXZzSwXcHc',
      'reckey_SXZzSwXcHf',
      'reckey_SXZzSwXcHi',
      'reckey_SXZzSwXcHp',
      'reckey_SXZzSwXcHv',
      'reckey_SXZzSwXhHc',
      'reckey_SXZzSwXhHf',
      'reckey_SXZzSwXhHi',
      'reckey_SXZzSwXhHp',
      'reckey_SXZzSwXhHv',
      'reckey_SXZzSwXtHc',
      'reckey_SXZzSwXtHf',
      'reckey_SXZzSwXtHi',
      'reckey_SXZzSwXtHp',
      'reckey_SXZzSwXtHv',
      'ベーカリー',
      '料理と一緒に楽しむパン',
      '素材を楽しむパン',
    ],
    price: 28000,
    price_min: 28000,
    price_max: 28000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 42893764821246,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7610994',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: 'くるみブレッド（2個入）',
        public_title: null,
        options: ['Default Title'],
        price: 28000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: '',
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 26600,
              },
            ],
            price: 26600,
            compare_at_price: 28000,
            per_delivery_price: 26600,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 26600,
              },
            ],
            price: 26600,
            compare_at_price: 28000,
            per_delivery_price: 26600,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 26600,
              },
            ],
            price: 26600,
            compare_at_price: 28000,
            per_delivery_price: 26600,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0001-001_01_e3b87781-daf1-4ee9-985d-1a5b358e01a5.png?v=1655535629',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0018-001_02.png?v=1655535629',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0018-003.png?v=1676856042',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0018-001_04.png?v=1676856042',
    ],
    featured_image:
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0001-001_01_e3b87781-daf1-4ee9-985d-1a5b358e01a5.png?v=1655535629',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/be-0018-001',
    media: [
      {
        alt: null,
        id: 30089598533886,
        position: 1,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0001-001_01_e3b87781-daf1-4ee9-985d-1a5b358e01a5.png?v=1655535629',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0001-001_01_e3b87781-daf1-4ee9-985d-1a5b358e01a5.png?v=1655535629',
        width: 1500,
      },
      {
        alt: 'くるみブレッド_断面',
        id: 30069361705214,
        position: 2,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0018-001_02.png?v=1655535629',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0018-001_02.png?v=1655535629',
        width: 1500,
      },
      {
        alt: 'くるみブレッド_シーン',
        id: 31866774520062,
        position: 3,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0018-003.png?v=1676856042',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0018-003.png?v=1676856042',
        width: 1500,
      },
      {
        alt: 'くるみブレッド_個包装',
        id: 30069361770750,
        position: 4,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0018-001_04.png?v=1676856042',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0018-001_04.png?v=1676856042',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回お届けプラン', '2週に1回お届けプラン', '4週に1回お届けプラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回お届けプラン',
            description: '週に1回商品をお届けします',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回お届けプラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回お届けプラン',
            description: '2週に1回商品をお届けします',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回お届けプラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回お届けプラン',
            description: '4週に1回商品をお届けします',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回お届けプラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '2個\n※焼き色や大きさには個体差がございます。',
      },
      {
        title: '原材料',
        content:
          '小麦粉、くるみ、砂糖、小麦全粒粉、全卵、ショートニング、マーガリン、イースト、乳等を主要原料とする食品、小麦グルテン、食塩、牛乳、油脂加工品、還元水あめ、脱脂粉乳／加工デンプン、乳化剤、香料、ビタミンC、カロチノイド色素、（一部に小麦・卵・乳成分・くるみ・大豆を含む）',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content: 'エネルギー 161kcal、たんぱく質 4.4g、脂質 5.6g、炭水化物 22.9g、食塩相当量 0.4g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: '小麦',
            content: true,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: true,
          },
          {
            title: '乳成分',
            content: true,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: false,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'くるみ',
            content: true,
          },
          {
            title: 'ごま',
            content: false,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: true,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: false,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },

      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約φ65㎜×約H34㎜ / 約22g',
      },
      {
        title: 'お召し上がり方法',
        content: '袋のまま室温（約25℃）で約3時間解凍してください。',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上※パッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '',
    allergy_caution: '',
  },
  // ブール / 湯種仕込
  {
    id: 7705872597246,
    title: 'ブール / 湯種仕込',
    handle: 'be-0009-001',
    description:
      '湯種・石臼挽き小麦粉をブレンドし、表面はパリッと中はもちっとした食感が楽しめるハード系のシンプルなパンです。長年受け継がれる独自発酵種ならではの、豊かな風味と小麦本来の甘みをお楽しみいただけます。',
    published_at: '2022-06-07T16:16:42+09:00',
    created_at: '2022-06-07T16:16:42+09:00',
    vendor: '食+',
    type: '',
    tags: [
      'all',
      'reckey_HXXxXhHc',
      'reckey_HXXxXhHf',
      'reckey_HXXxXhHi',
      'reckey_HXXxXhHp',
      'reckey_HXXxXhHv',
      'reckey_HXZzHcXh',
      'reckey_HXZzHfXh',
      'reckey_HXZzHiXh',
      'reckey_HXZzHpXh',
      'reckey_HXZzHvXh',
      'reckey_SESsSaHc',
      'reckey_SESsSaHf',
      'reckey_SESsSaHi',
      'reckey_SESsSaHp',
      'reckey_SESsSaHv',
      'reckey_SEZzSaEbHc',
      'reckey_SEZzSaEbHf',
      'reckey_SEZzSaEbHi',
      'reckey_SEZzSaEbHp',
      'reckey_SEZzSaEbHv',
      'reckey_SEZzSaEsHc',
      'reckey_SEZzSaEsHf',
      'reckey_SEZzSaEsHi',
      'reckey_SEZzSaEsHp',
      'reckey_SEZzSaEsHv',
      'reckey_SXSsSaHc',
      'reckey_SXSsSaHf',
      'reckey_SXSsSaHi',
      'reckey_SXSsSaHp',
      'reckey_SXSsSaHv',
      'reckey_SXXxXhHc',
      'reckey_SXXxXhHf',
      'reckey_SXXxXhHi',
      'reckey_SXXxXhHp',
      'reckey_SXXxXhHv',
      'reckey_SXZzSaXcHc',
      'reckey_SXZzSaXcHf',
      'reckey_SXZzSaXcHi',
      'reckey_SXZzSaXcHp',
      'reckey_SXZzSaXcHv',
      'reckey_SXZzSaXhHc',
      'reckey_SXZzSaXhHf',
      'reckey_SXZzSaXhHi',
      'reckey_SXZzSaXhHp',
      'reckey_SXZzSaXhHv',
      'reckey_SXZzSaXtHc',
      'reckey_SXZzSaXtHf',
      'reckey_SXZzSaXtHi',
      'reckey_SXZzSaXtHp',
      'reckey_SXZzSaXtHv',
      'reckey_SXZzSlXhHc',
      'reckey_SXZzSlXhHf',
      'reckey_SXZzSlXhHi',
      'reckey_SXZzSlXhHp',
      'reckey_SXZzSlXhHv',
      'reckey_SXZzSoXhHc',
      'reckey_SXZzSoXhHf',
      'reckey_SXZzSoXhHi',
      'reckey_SXZzSoXhHp',
      'reckey_SXZzSoXhHv',
      'reckey_SXZzSwXhHc',
      'reckey_SXZzSwXhHf',
      'reckey_SXZzSwXhHi',
      'reckey_SXZzSwXhHp',
      'reckey_SXZzSwXhHv',
      'ベーカリー',
      '挟んで楽しむパン',
      '料理と一緒に楽しむパン',
    ],
    price: 25000,
    price_min: 25000,
    price_max: 25000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 42893764395262,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7611014',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: 'ブール / 湯種仕込',
        public_title: null,
        options: ['Default Title'],
        price: 25000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: '',
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 23800,
              },
            ],
            price: 23800,
            compare_at_price: 25000,
            per_delivery_price: 23800,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 23800,
              },
            ],
            price: 23800,
            compare_at_price: 25000,
            per_delivery_price: 23800,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 23800,
              },
            ],
            price: 23800,
            compare_at_price: 25000,
            per_delivery_price: 23800,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0009-001_01.png?v=1655178570',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0009-001_02.png?v=1655191823',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0009-001_04.png?v=1655191824',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/what_s-plant-based_dd9d36be-185e-4847-b8cf-d89f13e028c4.png?v=1676614168',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0009-001_01.png?v=1655178570',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/be-0009-001',
    media: [
      {
        alt: 'ブール / 湯種仕込',
        id: 30068816937214,
        position: 1,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0009-001_01.png?v=1655178570',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0009-001_01.png?v=1655178570',
        width: 1500,
      },
      {
        alt: 'ブール / 湯種仕込_断面',
        id: 30069458108670,
        position: 2,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0009-001_02.png?v=1655191823',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0009-001_02.png?v=1655191823',
        width: 1500,
      },
      {
        alt: 'ブール / 湯種仕込_個包装',
        id: 30069458141438,
        position: 3,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0009-001_04.png?v=1655191824',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0009-001_04.png?v=1655191824',
        width: 1500,
      },
      {
        alt: null,
        id: 31850993123582,
        position: 4,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/what_s-plant-based_dd9d36be-185e-4847-b8cf-d89f13e028c4.png?v=1676614168',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/what_s-plant-based_dd9d36be-185e-4847-b8cf-d89f13e028c4.png?v=1676614168',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回お届けプラン', '2週に1回お届けプラン', '4週に1回お届けプラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回お届けプラン',
            description: '週に1回商品をお届けします',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回お届けプラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回お届けプラン',
            description: '2週に1回商品をお届けします',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回お届けプラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回お届けプラン',
            description: '4週に1回商品をお届けします',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回お届けプラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '1個',
      },
      {
        title: '原材料',
        content:
          '小麦粉（国内製造）、湯種（小麦粉、砂糖、食塩、オリゴ糖）、オリーブ油、食塩、ショートニング、モルトエキス、イースト、小麦モルト、アセロラパウダー／ビタミンＣ、（一部に小麦を含む）',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content: 'エネルギー 162kcal、たんぱく質 5.5g、脂質 2.1g、炭水化物 30.4g、食塩相当量 0.8g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: true,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: true,
          },
          {
            title: '乳成分',
            content: true,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: false,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: false,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: false,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: false,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },

      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約φ85㎜×約H58㎜ / 約59g',
      },
      {
        title: 'お召し上がり方法',
        content: '袋のまま室温（約25℃）で約3時間解凍してください。',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上※パッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '※本品製造ラインでは卵・乳成分を含む製品を製造しております。',
    allergy_caution: '',
  },
  // ライ麦パン / 全粒粉入り（2個入）
  {
    id: 7705872531710,
    title: 'ライ麦パン / 全粒粉入り（2個入）',
    handle: 'be-0007-001',
    description:
      'ライ麦に全粒粉を配合した粒々とした食感と香ばしさをお楽しみいただける食卓パンです。小麦の表皮や胚芽をまるごと粉砕した全粒粉を使用。',
    published_at: '2022-06-07T16:16:41+09:00',
    created_at: '2022-06-07T16:16:41+09:00',
    vendor: '食+',
    type: '',
    tags: [
      'all',
      'reckey_HEHhHi',
      'reckey_HEHhHp',
      'reckey_HEHhHv',
      'reckey_HEZzHiEb',
      'reckey_HEZzHiEs',
      'reckey_HEZzHpEb',
      'reckey_HEZzHpEs',
      'reckey_HEZzHvEb',
      'reckey_HEZzHvEs',
      'reckey_HXHhHi',
      'reckey_HXHhHp',
      'reckey_HXHhHv',
      'reckey_HXZzHiXc',
      'reckey_HXZzHiXh',
      'reckey_HXZzHiXt',
      'reckey_HXZzHpXc',
      'reckey_HXZzHpXh',
      'reckey_HXZzHpXt',
      'reckey_HXZzHvXc',
      'reckey_HXZzHvXh',
      'reckey_HXZzHvXt',
      'reckey_SESsSlHc',
      'reckey_SESsSlHf',
      'reckey_SESsSlHi',
      'reckey_SESsSlHp',
      'reckey_SESsSlHv',
      'reckey_SEZzSlEbHc',
      'reckey_SEZzSlEbHf',
      'reckey_SEZzSlEbHi',
      'reckey_SEZzSlEbHp',
      'reckey_SEZzSlEbHv',
      'reckey_SEZzSlEsHc',
      'reckey_SEZzSlEsHf',
      'reckey_SEZzSlEsHi',
      'reckey_SEZzSlEsHp',
      'reckey_SEZzSlEsHv',
      'reckey_SXSsSlHc',
      'reckey_SXSsSlHf',
      'reckey_SXSsSlHi',
      'reckey_SXSsSlHp',
      'reckey_SXSsSlHv',
      'reckey_SXZzSlXcHc',
      'reckey_SXZzSlXcHf',
      'reckey_SXZzSlXcHi',
      'reckey_SXZzSlXcHp',
      'reckey_SXZzSlXcHv',
      'reckey_SXZzSlXtHc',
      'reckey_SXZzSlXtHf',
      'reckey_SXZzSlXtHi',
      'reckey_SXZzSlXtHp',
      'reckey_SXZzSlXtHv',
      'ベーカリー',
      '料理と一緒に楽しむパン',
      '素材を楽しむパン',
    ],
    price: 25000,
    price_min: 25000,
    price_max: 25000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 42893764329726,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7611012',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: 'ライ麦パン / 全粒粉入り（2個入）',
        public_title: null,
        options: ['Default Title'],
        price: 25000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: '',
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 23800,
              },
            ],
            price: 23800,
            compare_at_price: 25000,
            per_delivery_price: 23800,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 23800,
              },
            ],
            price: 23800,
            compare_at_price: 25000,
            per_delivery_price: 23800,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 23800,
              },
            ],
            price: 23800,
            compare_at_price: 25000,
            per_delivery_price: 23800,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0007-001_01.png?v=1655178661',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0007-001_02.png?v=1655188406',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0007-001_04.png?v=1655189335',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0007-001_03.png?v=1681143856',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/what_s-plant-based_6afbc492-8058-4f9f-90d6-cf99988c7ae7.png?v=1681143856',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0007-001_01.png?v=1655178661',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/be-0007-001',
    media: [
      {
        alt: 'ライ麦パン / 全粒粉入り',
        id: 30068823294206,
        position: 1,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0007-001_01.png?v=1655178661',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0007-001_01.png?v=1655178661',
        width: 1500,
      },
      {
        alt: 'ライ麦パン / 全粒粉入り_断面',
        id: 30069321007358,
        position: 2,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0007-001_02.png?v=1655188406',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0007-001_02.png?v=1655188406',
        width: 1500,
      },
      {
        alt: 'ライ麦パン / 全粒粉入り_個包装',
        id: 30069356724478,
        position: 3,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0007-001_04.png?v=1655189335',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0007-001_04.png?v=1655189335',
        width: 1500,
      },
      {
        alt: null,
        id: 32188196159742,
        position: 4,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0007-001_03.png?v=1681143856',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0007-001_03.png?v=1681143856',
        width: 1500,
      },
      {
        alt: null,
        id: 31850993549566,
        position: 5,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/what_s-plant-based_6afbc492-8058-4f9f-90d6-cf99988c7ae7.png?v=1681143856',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/what_s-plant-based_6afbc492-8058-4f9f-90d6-cf99988c7ae7.png?v=1681143856',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回お届けプラン', '2週に1回お届けプラン', '4週に1回お届けプラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回お届けプラン',
            description: '週に1回商品をお届けします',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回お届けプラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回お届けプラン',
            description: '2週に1回商品をお届けします',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回お届けプラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回お届けプラン',
            description: '4週に1回商品をお届けします',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回お届けプラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '2個\n※焼き色や大きさには個体差がございます。',
      },
      {
        title: '原材料',
        content:
          '小麦粉（国内製造）、ライ麦、小麦全粒粉、ライ麦全粒粉、砂糖、イースト、ショートニング、食塩、モルトエキス、小麦モルト／ビタミンＣ、（一部に小麦を含む）',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content: 'エネルギー 153kcal、たんぱく質 5.7g、脂質 1.5g、炭水化物 29.3g、食塩相当量 0.7g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: true,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: true,
          },
          {
            title: '乳成分',
            content: true,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: false,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: true,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: false,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: false,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },

      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約77㎜×約70㎜×約40㎜ / 約28g',
      },
      {
        title: 'お召し上がり方法',
        content: '袋のまま室温（約25℃）で約3時間解凍してください。',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上※パッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '※本品製造ラインでは卵・乳成分・ごまを含む製品を製造しております。',
    allergy_caution: '',
  },
  // クロワッサン（2個入）
  {
    id: 7705872564478,
    title: 'クロワッサン（2個入）',
    handle: 'be-0008-001',
    description:
      '油脂には贅沢にバターを100%使うことで、深いコクと芳醇な風味が口の中にふわっと広がるクロワッサン。自家製の発酵液を仕込んだ生地は何重にも折り込まれ、ひとつひとつ丁寧に手作業で巻き上げました。',
    published_at: '2022-06-07T16:16:41+09:00',
    created_at: '2022-06-07T16:16:41+09:00',
    vendor: '食+',
    type: '',
    tags: [
      'all',
      'reckey_HXXxXcHc',
      'reckey_HXXxXcHf',
      'reckey_HXXxXcHi',
      'reckey_HXXxXcHp',
      'reckey_HXXxXcHv',
      'reckey_HXZzHcXc',
      'reckey_HXZzHfXc',
      'reckey_HXZzHiXc',
      'reckey_HXZzHpXc',
      'reckey_HXZzHvXc',
      'reckey_SESsSlHc',
      'reckey_SESsSlHf',
      'reckey_SESsSlHi',
      'reckey_SESsSlHp',
      'reckey_SESsSlHv',
      'reckey_SEZzSlEbHc',
      'reckey_SEZzSlEbHf',
      'reckey_SEZzSlEbHi',
      'reckey_SEZzSlEbHp',
      'reckey_SEZzSlEbHv',
      'reckey_SEZzSlEsHc',
      'reckey_SEZzSlEsHf',
      'reckey_SEZzSlEsHi',
      'reckey_SEZzSlEsHp',
      'reckey_SEZzSlEsHv',
      'reckey_SXSsSlHc',
      'reckey_SXSsSlHf',
      'reckey_SXSsSlHfHc',
      'reckey_SXSsSlHfHi',
      'reckey_SXSsSlHfHp',
      'reckey_SXSsSlHfHv',
      'reckey_SXSsSlHi',
      'reckey_SXSsSlHp',
      'reckey_SXSsSlHv',
      'reckey_SXXxXcHc',
      'reckey_SXXxXcHf',
      'reckey_SXXxXcHi',
      'reckey_SXXxXcHp',
      'reckey_SXXxXcHv',
      'reckey_SXZzSaXcHc',
      'reckey_SXZzSaXcHf',
      'reckey_SXZzSaXcHi',
      'reckey_SXZzSaXcHp',
      'reckey_SXZzSaXcHv',
      'reckey_SXZzSlXcHc',
      'reckey_SXZzSlXcHf',
      'reckey_SXZzSlXcHi',
      'reckey_SXZzSlXcHp',
      'reckey_SXZzSlXcHv',
      'reckey_SXZzSlXtHc',
      'reckey_SXZzSlXtHf',
      'reckey_SXZzSlXtHi',
      'reckey_SXZzSlXtHp',
      'reckey_SXZzSlXtHv',
      'reckey_SXZzSoXcHc',
      'reckey_SXZzSoXcHf',
      'reckey_SXZzSoXcHi',
      'reckey_SXZzSoXcHp',
      'reckey_SXZzSoXcHv',
      'reckey_SXZzSwXcHc',
      'reckey_SXZzSwXcHf',
      'reckey_SXZzSwXcHi',
      'reckey_SXZzSwXcHp',
      'reckey_SXZzSwXcHv',
      'ベーカリー',
      '挟んで楽しむパン',
      '料理と一緒に楽しむパン',
      '風味や食感を楽しむパン',
    ],
    price: 30000,
    price_min: 30000,
    price_max: 30000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 42893764362494,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7610998',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: 'クロワッサン（2個入）',
        public_title: null,
        options: ['Default Title'],
        price: 30000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: '',
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 28500,
              },
            ],
            price: 28500,
            compare_at_price: 30000,
            per_delivery_price: 28500,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 28500,
              },
            ],
            price: 28500,
            compare_at_price: 30000,
            per_delivery_price: 28500,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 28500,
              },
            ],
            price: 28500,
            compare_at_price: 30000,
            per_delivery_price: 28500,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0008-001_01.png?v=1655178228',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0008-001_02.png?v=1655191578',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0008-001_04.png?v=1655191581',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0008-001_01.png?v=1655178228',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/be-0008-001',
    media: [
      {
        alt: 'クロワッサン',
        id: 30068793442558,
        position: 1,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0008-001_01.png?v=1655178228',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0008-001_01.png?v=1655178228',
        width: 1500,
      },
      {
        alt: 'クロワッサン_断面',
        id: 30069449949438,
        position: 2,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0008-001_02.png?v=1655191578',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0008-001_02.png?v=1655191578',
        width: 1500,
      },
      {
        alt: 'クロワッサン_個包装',
        id: 30069450014974,
        position: 3,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0008-001_04.png?v=1655191581',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0008-001_04.png?v=1655191581',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回お届けプラン', '2週に1回お届けプラン', '4週に1回お届けプラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回お届けプラン',
            description: '週に1回商品をお届けします',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回お届けプラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回お届けプラン',
            description: '2週に1回商品をお届けします',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回お届けプラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回お届けプラン',
            description: '4週に1回商品をお届けします',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回お届けプラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '2個\n※焼き色や大きさには個体差がございます。',
      },
      {
        title: '原材料',
        content:
          '小麦粉、バター、砂糖、全卵、イースト、加糖卵黄、食塩、還元水あめ、クリーム、小麦グルテン、脱脂粉乳、酵母エキス／乳化剤、ビタミンＣ、（一部に小麦・卵・乳成分を含む）',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content: 'エネルギー 180kcal、たんぱく質 2.8g、脂質 10.5g、炭水化物 18.9g、食塩相当量 0.4g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: true,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: true,
          },
          {
            title: '乳成分',
            content: true,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: false,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: false,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: false,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: false,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },

      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約100㎜×約63㎜×約40㎜ / 約19g',
      },
      {
        title: 'お召し上がり方法',
        content: '袋のまま室温（約25℃）で約3時間解凍してください。',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上※パッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '',
    allergy_caution: '',
  },
  // コーンブレッド（2個入）
  {
    id: 7705872498942,
    title: 'コーンブレッド（2個入）',
    handle: 'be-0006-001',
    description:
      'やさしい甘みのコーンを混ぜ込み、風味豊かに焼き上げました。コーンのプチプチした食感ともっちりとしたパン生地がおいしさのポイントです。',
    published_at: '2022-06-07T16:16:40+09:00',
    created_at: '2022-06-07T16:16:40+09:00',
    vendor: '食+',
    type: '',
    tags: [
      'all',
      'reckey_HEHhHf',
      'reckey_HEHhHv',
      'reckey_HEZzHfEb',
      'reckey_HEZzHfEs',
      'reckey_HEZzHvEb',
      'reckey_HEZzHvEs',
      'reckey_HXHhHf',
      'reckey_HXHhHv',
      'reckey_HXXxXcHc',
      'reckey_HXXxXcHf',
      'reckey_HXXxXcHi',
      'reckey_HXXxXcHp',
      'reckey_HXXxXcHv',
      'reckey_HXZzHcXc',
      'reckey_HXZzHfXc',
      'reckey_HXZzHfXh',
      'reckey_HXZzHfXt',
      'reckey_HXZzHiXc',
      'reckey_HXZzHpXc',
      'reckey_HXZzHvXc',
      'reckey_HXZzHvXh',
      'reckey_HXZzHvXt',
      'reckey_SXXxXcHc',
      'reckey_SXXxXcHf',
      'reckey_SXXxXcHi',
      'reckey_SXXxXcHp',
      'reckey_SXXxXcHv',
      'reckey_SXZzSaXcHc',
      'reckey_SXZzSaXcHf',
      'reckey_SXZzSaXcHi',
      'reckey_SXZzSaXcHp',
      'reckey_SXZzSaXcHv',
      'reckey_SXZzSlXcHc',
      'reckey_SXZzSlXcHf',
      'reckey_SXZzSlXcHi',
      'reckey_SXZzSlXcHp',
      'reckey_SXZzSlXcHv',
      'reckey_SXZzSoXcHc',
      'reckey_SXZzSoXcHf',
      'reckey_SXZzSoXcHi',
      'reckey_SXZzSoXcHp',
      'reckey_SXZzSoXcHv',
      'reckey_SXZzSwXcHc',
      'reckey_SXZzSwXcHf',
      'reckey_SXZzSwXcHi',
      'reckey_SXZzSwXcHp',
      'reckey_SXZzSwXcHv',
      'ベーカリー',
      '料理と一緒に楽しむパン',
      '素材を楽しむパン',
    ],
    price: 25000,
    price_min: 25000,
    price_max: 25000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 42893764296958,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7611001',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: 'コーンブレッド（2個入）',
        public_title: null,
        options: ['Default Title'],
        price: 25000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: '',
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 23800,
              },
            ],
            price: 23800,
            compare_at_price: 25000,
            per_delivery_price: 23800,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 23800,
              },
            ],
            price: 23800,
            compare_at_price: 25000,
            per_delivery_price: 23800,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 23800,
              },
            ],
            price: 23800,
            compare_at_price: 25000,
            per_delivery_price: 23800,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0006-001_01.png?v=1655180731',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0006-001_02.png?v=1655189750',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0006-003.png?v=1676856343',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0006-001_04.png?v=1676856343',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0006-001_01.png?v=1655180731',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/be-0006-001',
    media: [
      {
        alt: 'コーンブレッド',
        id: 30068964917502,
        position: 1,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0006-001_01.png?v=1655180731',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0006-001_01.png?v=1655180731',
        width: 1500,
      },
      {
        alt: 'コーンブレッド_断面',
        id: 30069369274622,
        position: 2,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0006-001_02.png?v=1655189750',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0006-001_02.png?v=1655189750',
        width: 1500,
      },
      {
        alt: 'コーンブレッド_シーン',
        id: 31866789527806,
        position: 3,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0006-003.png?v=1676856343',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0006-003.png?v=1676856343',
        width: 1500,
      },
      {
        alt: 'コーンブレッド_個包装',
        id: 30069369340158,
        position: 4,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0006-001_04.png?v=1676856343',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0006-001_04.png?v=1676856343',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回お届けプラン', '2週に1回お届けプラン', '4週に1回お届けプラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回お届けプラン',
            description: '週に1回商品をお届けします',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回お届けプラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回お届けプラン',
            description: '2週に1回商品をお届けします',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回お届けプラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回お届けプラン',
            description: '4週に1回商品をお届けします',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回お届けプラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '2個\n※焼き色や大きさには個体差がございます。',
      },
      {
        title: '原材料',
        content:
          '小麦粉（国内製造）、とうもろこし、マーガリン、砂糖、イースト、食塩、脱脂粉乳、小麦グルテン、小麦モルト、アセロラパウダー／加工デンプン、（一部に小麦・乳成分・大豆を含む）',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content: 'エネルギー 122kcal、たんぱく質 4.0g、脂質 2.6g、炭水化物 20.8g、食塩相当量 0.5g',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: true,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: true,
          },
          {
            title: '乳成分',
            content: true,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: false,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: false,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: true,
          },
          {
            title: '鶏肉',
            content: true,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: false,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },

      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約65㎜×約55㎜×約35㎜ / 約22g',
      },
      {
        title: 'お召し上がり方法',
        content: '袋のまま室温（約25℃）で約3時間解凍してください。',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上※パッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '※本品製造ラインでは卵・豚肉を含む製品を製造しております。',
    allergy_caution: '',
  },
  //豆腐ブレッド（2個入り）
  {
    id: 7915326603518,
    title: '豆腐ブレッド（2個入り）',
    handle: 'be-0027-001',
    description:
      '動物性原材料不使用。豆腐ペーストと豆乳を使用し、素朴でやさしい味わいに仕上げた食事パンです。\n中種製法・低温焼成による、しっとりと柔らかい食感をおたのしみいただけます。\n',
    published_at: '2023-01-30T09:30:38+09:00',
    created_at: '2022-10-28T21:13:35+09:00',
    vendor: '食＋（ショクタス）公式オンラインショップ',
    type: '',
    tags: ['all', 'ビヨンドフリー', 'ベーカリー', '動物性原材料不使用'],
    price: 33000,
    price_min: 33000,
    price_max: 33000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 43652511596798,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7180006',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: '豆腐ブレッド（2個入り）',
        public_title: null,
        options: ['Default Title'],
        price: 33000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: null,
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 31400,
              },
            ],
            price: 31400,
            compare_at_price: 33000,
            per_delivery_price: 31400,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 31400,
              },
            ],
            price: 31400,
            compare_at_price: 33000,
            per_delivery_price: 31400,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 31400,
              },
            ],
            price: 31400,
            compare_at_price: 33000,
            per_delivery_price: 31400,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0027-001.png?v=1672099037',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0027-002.png?v=1674088656',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0027-003.png?v=1674088656',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/what_s-plant-based_3c3b7648-aab7-4a74-b112-8e64f9bcff9d.png?v=1675002807',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0027-001.png?v=1672099037',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/be-0027-001',
    media: [
      {
        alt: '豆腐ブレッド',
        id: 31526649856254,
        position: 1,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0027-001.png?v=1672099037',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0027-001.png?v=1672099037',
        width: 1500,
      },
      {
        alt: null,
        id: 31678634459390,
        position: 2,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0027-002.png?v=1674088656',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0027-002.png?v=1674088656',
        width: 1500,
      },
      {
        alt: null,
        id: 31674293977342,
        position: 3,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0027-003.png?v=1674088656',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0027-003.png?v=1674088656',
        width: 1500,
      },
      {
        alt: null,
        id: 31734953738494,
        position: 4,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/what_s-plant-based_3c3b7648-aab7-4a74-b112-8e64f9bcff9d.png?v=1675002807',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/what_s-plant-based_3c3b7648-aab7-4a74-b112-8e64f9bcff9d.png?v=1675002807',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回ご注文プラン', '2週に1回ご注文プラン', '4週に1回ご注文プラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回ご注文プラン',
            description: '週1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回ご注文プラン',
            description: '2週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回ご注文プラン',
            description: '4週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '2個',
      },
      {
        title: '原材料',
        content:
          '小麦粉（国内製造）、豆乳、豆腐ペースト、ショートニング、砂糖、イースト、食塩／乳化剤、豆腐用凝固剤、ビタミンC、（一部に小麦・大豆を含む）',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content: 'エネルギー:149kcal たんぱく質:4.4g 脂質:4.0g 炭水化物:23.9g 食塩相当量:0.5g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: true,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: false,
          },
          {
            title: '乳成分',
            content: false,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: false,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: false,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: true,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: false,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },

      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約φ60㎜×約H40㎜ /約25g',
      },
      {
        title: 'お召し上がり方法',
        content: '袋のまま室温（約25℃）で約３時間解凍してください。',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上※パッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '※本品製造ラインでは卵・乳成分・ごまを含む製品を製造しております。',
    allergy_caution: '',
  },
  //豆乳プリン（2個入り）
  {
    id: 7915323621630,
    title: '豆乳プリン（2個入り）',
    handle: 'de-0010-001',
    description:
      'アレルゲン「乳」不使用。豆乳で作ったぷるんとした食感が特長のヘルシーなプリンです。\nカップ入りなので冷凍庫から出して自然解凍するだけでお召しあがりいただけます。\nお子様にもぴったりなやさしい甘みとサイズ感で、食後のデザートやおやつなどでおたのしみください。',
    published_at: '2023-01-30T08:53:09+09:00',
    created_at: '2022-10-28T21:10:19+09:00',
    vendor: '食＋（ショクタス）公式オンラインショップ',
    type: '',
    tags: ['all', 'アレルゲン不使用', 'デザート', 'ビヨンドフリー', '乳不使用'],
    price: 40000,
    price_min: 40000,
    price_max: 40000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 43652504223998,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7180002',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: '豆乳プリン（2個入り）',
        public_title: null,
        options: ['Default Title'],
        price: 40000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: '',
        requires_selling_plan: false,
        selling_plan_allocations: [],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0010-001_v1.png?v=1671547435',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0010-002.png?v=1674095636',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0010-003.png?v=1674096715',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0010-003_198b58d2-286c-4957-b701-2272a93b9f6e.png?v=1674096714',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0010-001_v1.png?v=1671547435',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/de-0010-001',
    media: [
      {
        alt: null,
        id: 31479022715134,
        position: 1,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0010-001_v1.png?v=1671547435',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0010-001_v1.png?v=1671547435',
        width: 1500,
      },
      {
        alt: null,
        id: 31679467290878,
        position: 2,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0010-002.png?v=1674095636',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0010-002.png?v=1674095636',
        width: 1500,
      },
      {
        alt: null,
        id: 31679572541694,
        position: 3,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0010-003.png?v=1674096715',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0010-003.png?v=1674096715',
        width: 1500,
      },
      {
        alt: null,
        id: 31674280182014,
        position: 4,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0010-003_198b58d2-286c-4957-b701-2272a93b9f6e.png?v=1674096714',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0010-003_198b58d2-286c-4957-b701-2272a93b9f6e.png?v=1674096714',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [],
    metafields: [
      {
        title: '内容量',
        content: '2個',
      },
      {
        title: '原材料',
        content:
          '粉あめ（国内製造）、砂糖、豆乳、加糖卵黄、果糖、カラメルソース、ぶどう糖果糖液糖、ショートニング、ゼラチン、ぶどう糖、寒天／糊料（加工デンプン、増粘多糖類）、着色料（カラメル、カロチノイド）、乳化剤、香料、ピロリン酸第二鉄、（一部に卵・大豆・ゼラチンを含む）',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content: 'エネルギー 44kcal、たんぱく質 0.5g、脂質 0.5g、炭水化物 9.4g、食塩相当量 0.02g、鉄 0.8mg',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: false,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: true,
          },
          {
            title: '乳成分',
            content: false,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: false,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: false,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: true,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: false,
          },
          {
            title: 'ゼラチン',
            content: true,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },

      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約φ70㎜×約H28㎜ /約40g',
      },
      {
        title: 'お召し上がり方法',
        content: '室温（約25℃）で50～80分解凍してください。',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上※パッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '※本品製造ラインでは乳成分を含む製品を製造しております。',
    allergy_caution: '※本品製造ラインでは乳成分を含む製品を製造しております。',
  },
  //豆乳クリーム ロールケーキ プレーン
  {
    id: 7915326898430,
    title: '豆乳クリーム ロールケーキ プレーン',
    handle: 'de-0015-001',
    description:
      'アレルゲン「卵」・「乳」不使用。簡単便利なトレー入りデザート。\nしっとりとした食感のスポンジに、バニラ風味の豆乳ホイップクリームを合わせたロールケーキです。\n動物性原材料不使用でも、しっかり濃厚な味わいを実現しました。\n冷凍庫から取り出して10分程度自然解凍したのちに、スプーンでお召しあがりください。\n',
    published_at: '2023-01-30T09:30:36+09:00',
    created_at: '2022-10-28T21:14:09+09:00',
    vendor: '食＋（ショクタス）公式オンラインショップ',
    type: '',
    tags: ['all', 'アレルゲン不使用', 'デザート', 'ビヨンドフリー', '動物性原材料不使用', '卵・乳不使用'],
    price: 49000,
    price_min: 49000,
    price_max: 49000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 43652512940286,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7180024',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: '豆乳クリーム ロールケーキ プレーン',
        public_title: null,
        options: ['Default Title'],
        price: 49000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: null,
        requires_selling_plan: false,
        selling_plan_allocations: [],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0015-001_v1.png?v=1671547634',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0015-002.png?v=1674091157',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0015-003.png?v=1674091157',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0015-001_v1.png?v=1671547634',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/de-0015-001',
    media: [
      {
        alt: null,
        id: 31479050993918,
        position: 1,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0015-001_v1.png?v=1671547634',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0015-001_v1.png?v=1671547634',
        width: 1500,
      },
      {
        alt: null,
        id: 31679011127550,
        position: 2,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0015-002.png?v=1674091157',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0015-002.png?v=1674091157',
        width: 1500,
      },
      {
        alt: null,
        id: 31674272055550,
        position: 3,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0015-003.png?v=1674091157',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0015-003.png?v=1674091157',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [],
    metafields: [
      {
        title: '内容量',
        content: '1個',
      },
      {
        title: '原材料',
        content:
          '豆乳加工食品（植物油脂、豆乳クリーム、水あめ、でん粉、食塩）（国内製造）、豆乳、砂糖、豆乳発酵食品、豆乳フラワーペースト、粉末調整豆乳、加工油脂、米粉、洋酒、乾燥おから、発酵調味料／加工デンプン、乳化剤、膨張剤、糊料（加工デンプン、増粘多糖類）、pH調整剤、グリシン、セルロース、塩化マグネシウム含有物、酸化防止剤（V.E）、塩化Mg、香料、保存料（ソルビン酸K）、ポリリン酸Na、着色料（カロチノイド、ウコン）、（一部に大豆を含む）',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content: 'エネルギー 211kcal、たんぱく質 3.1g、脂質 13.1g、炭水化物 20.1g、食塩相当量 0.3g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: false,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: false,
          },
          {
            title: '乳成分',
            content: false,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: false,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: false,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: true,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: false,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },

      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約φ90㎜×約H25㎜/68g',
      },
      {
        title: 'お召し上がり方法',
        content: '袋のまま室温（約25℃）で約10分自然解凍してお召しあがりください。',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上※パッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '※本品製造ラインでは小麦・卵・乳成分を含む製品を製造しております。',
    allergy_caution: '※本品製造ラインでは小麦・卵・乳成分を含む製品を製造しております。',
  },
  //豆乳クリーム ロールケーキ チョコ
  {
    id: 7915327914238,
    title: '豆乳クリーム ロールケーキ チョコ',
    handle: 'de-0016-001',
    description:
      'アレルゲン「卵」・「乳」不使用。簡単便利なトレー入りデザート。\nしっとりとした食感のココアスポンジに、チョコ風味の豆乳ホイップクリームを合わせたロールケーキです。\n動物性原材料不使用でも、しっかり濃厚な味わいを実現しました。\n冷凍庫から取り出して10分程度自然解凍したのちに、スプーンでお召しあがりください。',
    published_at: '2023-01-30T09:30:35+09:00',
    created_at: '2022-10-28T21:15:20+09:00',
    vendor: '食＋（ショクタス）公式オンラインショップ',
    type: '',
    tags: ['all', 'アレルゲン不使用', 'デザート', 'ビヨンドフリー', '動物性原材料不使用', '卵・乳不使用'],
    price: 49000,
    price_min: 49000,
    price_max: 49000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 43652517036286,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7180025',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: '豆乳クリーム ロールケーキ チョコ',
        public_title: null,
        options: ['Default Title'],
        price: 49000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: null,
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0016-001_v1.png?v=1671547494',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0016-002.png?v=1674091014',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0016-003.png?v=1674091014',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0016-001_v1.png?v=1671547494',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/de-0016-001',
    media: [
      {
        alt: null,
        id: 31479030317310,
        position: 1,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0016-001_v1.png?v=1671547494',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0016-001_v1.png?v=1671547494',
        width: 1500,
      },
      {
        alt: null,
        id: 31678998937854,
        position: 2,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0016-002.png?v=1674091014',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0016-002.png?v=1674091014',
        width: 1500,
      },
      {
        alt: null,
        id: 31674276675838,
        position: 3,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0016-003.png?v=1674091014',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0016-003.png?v=1674091014',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回ご注文プラン', '2週に1回ご注文プラン', '4週に1回ご注文プラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回ご注文プラン',
            description: '週1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回ご注文プラン',
            description: '2週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回ご注文プラン',
            description: '4週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '1個',
      },
      {
        title: '原材料',
        content:
          '豆乳加工食品（植物油脂、豆乳クリーム、水あめ、でん粉、食塩）（国内製造）、豆乳、豆乳フラワーペースト、カカオマス、砂糖、加工黒糖、水あめ、粉末調整豆乳、加工油脂、ココアパウダー、米粉、乾燥おから、発酵調味料、食塩／加工デンプン、トレハロース、乳化剤、糊料（加工デンプン、カロブビーンガム）、膨張剤、pH調整剤、セルロース、グリシン、酸化防止剤（V.E）、塩化Mg、保存料（ソルビン酸K）、ポリリン酸Na、香料、着色料（カロチノイド、ウコン）、（一部に大豆を含む）',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content: 'エネルギー 275kcal、たんぱく質 4.0g、脂質 16.9g、炭水化物 26.8g、食塩相当量 0.4g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: false,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: false,
          },
          {
            title: '乳成分',
            content: false,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: false,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: false,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: true,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: false,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },

      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約φ90㎜×約H25㎜/83g',
      },
      {
        title: 'お召し上がり方法',
        content: '袋のまま室温（約25℃）で約10分自然解凍してお召しあがりください。',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上※パッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '※本品製造ラインでは小麦・卵・乳成分を含む製品を製造しております。',
    allergy_caution: '※本品製造ラインでは小麦・卵・乳成分を含む製品を製造しております。',
  },
  //豆乳のカップデザート 宇治抹茶
  {
    id: 7915328176382,
    title: '豆乳のカップデザート 宇治抹茶',
    handle: 'de-0017-001',
    description:
      '動物性原材料不使用。簡単便利なカップ入りデザート。\n豆乳原料を使用した香り豊かな宇治抹茶ムースに宇治抹茶ゼリー＆栗甘露煮をトッピング。\n食感のアクセントとして米粉とアーモンドで作ったクランブルを組合わせました。\n冷凍庫から取り出して10分程度自然解凍したのちに、スプーンでお召しあがりください。',
    published_at: '2023-01-30T09:30:33+09:00',
    created_at: '2022-10-28T21:15:31+09:00',
    vendor: '食＋（ショクタス）公式オンラインショップ',
    type: '',
    tags: ['all', 'デザート', 'ビヨンドフリー', '動物性原材料不使用'],
    price: 49000,
    price_min: 49000,
    price_max: 49000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 43652517888254,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7180026',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: '豆乳のカップデザート 宇治抹茶',
        public_title: null,
        options: ['Default Title'],
        price: 49000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: '',
        requires_selling_plan: false,
        selling_plan_allocations: [],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0017-001.png?v=1672098294',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0017-002.png?v=1674093002',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0017-003.png?v=1674093002',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0017-001.png?v=1672098294',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/de-0017-001',
    media: [
      {
        alt: '豆乳のカップデザート 宇治抹茶',
        id: 31526596837630,
        position: 1,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0017-001.png?v=1672098294',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0017-001.png?v=1672098294',
        width: 1500,
      },
      {
        alt: null,
        id: 31679181291774,
        position: 2,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0017-002.png?v=1674093002',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0017-002.png?v=1674093002',
        width: 1500,
      },
      {
        alt: null,
        id: 31674268352766,
        position: 3,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0017-003.png?v=1674093002',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0017-003.png?v=1674093002',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [],
    metafields: [
      {
        title: '内容量',
        content: '1個',
      },
      {
        title: '原材料',
        content:
          '豆乳加工食品（植物油脂、豆乳クリーム、水あめ、でん粉、食塩）（国内製造）、砂糖、栗甘露煮、豆乳発酵食品、水あめ、豆乳フラワーペースト、米粉、ショートニング、アーモンドパウダー、抹茶、寒天加工品、クロレラ／トレハロース、糊料（加工デンプン、増粘多糖類）、乳化剤、pH調整剤、グリシン、セルロース、クチナシ色素、酸化防止剤（V.E、V.C）、塩化マグネシウム含有物、塩化Mg、保存料（ソルビン酸K）、ポリリン酸Na、香料、漂白剤（亜硫酸塩）、（一部にアーモンド・大豆を含む）',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content: 'エネルギー 260kcal、たんぱく質 2.1g、脂質 16.1g、炭水化物 26.6g、食塩相当量 0.1g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: false,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: false,
          },
          {
            title: '乳成分',
            content: false,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: true,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: false,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: true,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: false,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },

      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約φ70㎜×約H50㎜/75g',
      },
      {
        title: 'お召し上がり方法',
        content: '袋のまま室温（約25℃）で約10分自然解凍してお召しあがりください。',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上※パッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '※本品製造ラインでは小麦を含む製品を製造しております。',
    allergy_caution: '',
  },
  //豆乳のカップデザート マンゴー
  {
    id: 7915328471294,
    title: '豆乳のカップデザート マンゴー',
    handle: 'de-0019-001',
    description:
      '動物性原材料不使用。簡単便利なカップ入りデザート。\n豆乳原料を使用した甘く濃厚な味わいのマンゴームースにマンゴーゼリー＆豆乳ホイップクリーム、抹茶をまぶしたアーモンドをトッピング。\n食感のアクセントとして米粉とアーモンドで作ったクランブルを組合わせました。\n冷凍庫から取り出して10分程度自然解凍したのちに、スプーンでお召しあがりください。',
    published_at: '2023-01-30T09:30:31+09:00',
    created_at: '2022-10-28T21:15:53+09:00',
    vendor: '食＋（ショクタス）公式オンラインショップ',
    type: '',
    tags: ['all', 'デザート', 'ビヨンドフリー', '動物性原材料不使用'],
    price: 49000,
    price_min: 49000,
    price_max: 49000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 43652519035134,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7180028',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: '豆乳のカップデザート マンゴー',
        public_title: null,
        options: ['Default Title'],
        price: 49000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: '',
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0019-001.png?v=1672098319',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0019-002.png?v=1674093071',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0019-003.png?v=1674093071',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0019-001.png?v=1672098319',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/de-0019-001',
    media: [
      {
        alt: '豆乳のカップデザート マンゴー',
        id: 31526599196926,
        position: 1,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0019-001.png?v=1672098319',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0019-001.png?v=1672098319',
        width: 1500,
      },
      {
        alt: null,
        id: 31679187353854,
        position: 2,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0019-002.png?v=1674093071',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0019-002.png?v=1674093071',
        width: 1500,
      },
      {
        alt: null,
        id: 31674264649982,
        position: 3,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0019-003.png?v=1674093071',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0019-003.png?v=1674093071',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回ご注文プラン', '2週に1回ご注文プラン', '4週に1回ご注文プラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回ご注文プラン',
            description: '週1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回ご注文プラン',
            description: '2週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回ご注文プラン',
            description: '4週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '1個',
      },
      {
        title: '原材料',
        content:
          '豆乳加工食品（植物油脂、豆乳クリーム、水あめ、でん粉、食塩）（国内製造）、マンゴーピューレ、砂糖、豆乳発酵食品、水あめ、米粉、ショートニング、アーモンドパウダー、でん粉分解物、寒天加工品、発酵調味料、アーモンド、食塩、抹茶、クロレラ／トレハロース、糊料（加工デンプン、増粘多糖類）、乳化剤、pH調整剤、グリシン、セルロース、塩化マグネシウム含有物、酸化防止剤（V.E）、塩化Mg、香料、カロチノイド色素、（一部にアーモンド・大豆を含む）',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content: 'エネルギー 205kcal、たんぱく質 1.6g、脂質 13.6g、炭水化物 19.0g、食塩相当量 0.1g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: true,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: false,
          },
          {
            title: '乳成分',
            content: false,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: true,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: false,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: true,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: false,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },

      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約φ70㎜×約H50㎜/69g',
      },
      {
        title: 'お召し上がり方法',
        content: '袋のまま室温（約25℃）で約10分自然解凍してお召しあがりください。',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上※パッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '※本品製造ラインでは小麦を含む製品を製造しております。',
    allergy_caution: '',
  },
  //豆乳のカップデザート ストロベリー
  {
    id: 7915328274686,
    title: '豆乳のカップデザート ストロベリー',
    handle: 'de-0018-001',
    description:
      '動物性原材料不使用。簡単便利なカップ入りデザート。\n豆乳原料を使用した爽やかな甘みのいちごムースにいちごコンポート＆豆乳ホイップクリーム、抹茶をまぶしたアーモンドをトッピング。\n食感のアクセントとして米粉とアーモンドで作ったクランブルを組合わせました。\n冷凍庫から取り出して10分程度自然解凍したのちに、スプーンでお召しあがりください。',
    published_at: '2023-01-30T09:30:29+09:00',
    created_at: '2022-10-28T21:15:43+09:00',
    vendor: '食＋（ショクタス）公式オンラインショップ',
    type: '',
    tags: ['all', 'デザート', 'ビヨンドフリー', '動物性原材料不使用'],
    price: 49000,
    price_min: 49000,
    price_max: 49000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 43652518183166,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7180027',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: '豆乳のカップデザート ストロベリー',
        public_title: null,
        options: ['Default Title'],
        price: 49000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: null,
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0018-001.png?v=1672097425',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0018-002.png?v=1674093036',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0018-003.png?v=1674093036',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0018-001.png?v=1672097425',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/de-0018-001',
    media: [
      {
        alt: '豆乳のカップデザート ストロベリー',
        id: 31526517178622,
        position: 1,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0018-001.png?v=1672097425',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0018-001.png?v=1672097425',
        width: 1500,
      },
      {
        alt: null,
        id: 31679183388926,
        position: 2,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0018-002.png?v=1674093036',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0018-002.png?v=1674093036',
        width: 1500,
      },
      {
        alt: null,
        id: 31674261176574,
        position: 3,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0018-003.png?v=1674093036',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0018-003.png?v=1674093036',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回ご注文プラン', '2週に1回ご注文プラン', '4週に1回ご注文プラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回ご注文プラン',
            description: '週1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回ご注文プラン',
            description: '2週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回ご注文プラン',
            description: '4週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '1個',
      },
      {
        title: '原材料',
        content:
          '豆乳加工食品（植物油脂、豆乳クリーム、水あめ、でん粉、食塩）（国内製造）、いちごピューレ（いちご、砂糖）、豆乳発酵食品、水あめ、いちご、いちご濃縮果汁、砂糖、米粉、豆乳フラワーペースト、ショートニング、アーモンドパウダー、洋酒、レモン果汁、アーモンド、寒天加工品、抹茶、クロレラ／トレハロース、糊料（加工デンプン、増粘多糖類）、乳化剤、pH調整剤、着色料（アカキャベツ、カロチノイド）、グリシン、セルロース、香料、塩化マグネシウム含有物、酸化防止剤（V.E）、塩化Mg、保存料（ソルビン酸K）、ポリリン酸Na、（一部にアーモンド・大豆を含む）',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content: 'エネルギー 201kcal、たんぱく質 1.7g、脂質 15.0g、炭水化物 14.7g、食塩相当量 0.09g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: false,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: false,
          },
          {
            title: '乳成分',
            content: false,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: true,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: false,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: true,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: false,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },

      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約φ70㎜×約H50㎜/63g',
      },
      {
        title: 'お召し上がり方法',
        content: '袋のまま室温（約25℃）で約10分自然解凍してお召しあがりください。',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上※パッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '※本品製造ラインでは小麦を含む製品を製造しております。',
    allergy_caution: '',
  },
  //豆乳とココアのデザート（2個入り）
  {
    id: 7915324408062,
    title: '豆乳とココアのデザート（2個入り）',
    handle: 'de-0011-001',
    description:
      'アレルゲン「卵」・「乳」不使用。豆乳で作ったぷるんとした食感が特長のココア風味デザートです。\nカップ入りなので冷凍庫から出して自然解凍するだけでお召しあがりいただけます。\nお子様にもぴったりなやさしい甘みとサイズ感で、食後のデザートやおやつなどでおたのしみください。',
    published_at: '2023-01-30T09:30:27+09:00',
    created_at: '2022-10-28T21:10:59+09:00',
    vendor: '食＋（ショクタス）公式オンラインショップ',
    type: '',
    tags: ['all', 'アレルゲン不使用', 'デザート', 'ビヨンドフリー', '卵・乳不使用'],
    price: 40000,
    price_min: 40000,
    price_max: 40000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 43652505567486,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7180003',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: '豆乳とココアのデザート（2個入り）',
        public_title: null,
        options: ['Default Title'],
        price: 40000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: null,
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 38000,
              },
            ],
            price: 38000,
            compare_at_price: 40000,
            per_delivery_price: 38000,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 38000,
              },
            ],
            price: 38000,
            compare_at_price: 40000,
            per_delivery_price: 38000,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 38000,
              },
            ],
            price: 38000,
            compare_at_price: 40000,
            per_delivery_price: 38000,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0011-001_v1.png?v=1671547378',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0011-002.png?v=1674095690',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0011-003.png?v=1674096735',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0011-001_v1.png?v=1671547378',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/de-0011-001',
    media: [
      {
        alt: null,
        id: 31479015833854,
        position: 1,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0011-001_v1.png?v=1671547378',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0011-001_v1.png?v=1671547378',
        width: 1500,
      },
      {
        alt: null,
        id: 31679471976702,
        position: 2,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0011-002.png?v=1674095690',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0011-002.png?v=1674095690',
        width: 1500,
      },
      {
        alt: null,
        id: 31679574737150,
        position: 3,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0011-003.png?v=1674096735',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0011-003.png?v=1674096735',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回ご注文プラン', '2週に1回ご注文プラン', '4週に1回ご注文プラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回ご注文プラン',
            description: '週1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回ご注文プラン',
            description: '2週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回ご注文プラン',
            description: '4週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '2個',
      },
      {
        title: '原材料',
        content:
          '砂糖（国内製造）、ぶどう糖果糖液糖、水あめ、油脂加工品、豆乳、カカオマス、ココアパウダー、こんにゃく粉／糊料（加工デンプン、増粘多糖類）、炭酸Ｃａ、香料、乳化剤、ピロリン酸第二鉄、（一部に大豆を含む）',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content: 'エネルギー 38kcal、たんぱく質 0.2g、脂質 0.8g、炭水化物 7.6g、食塩相当量 0.02g、カルシウム 46mg、鉄 0.6mg',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: false,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: false,
          },
          {
            title: '乳成分',
            content: false,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: false,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: false,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: true,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: false,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },

      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約φ70㎜×約H28㎜ /約40g',
      },
      {
        title: 'お召し上がり方法',
        content: '室温（約25℃）で50～80分解凍してください。',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上※パッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '※本品製造ラインでは卵・乳成分を含む製品を製造しております。',
    allergy_caution: '※本品製造ラインでは卵・乳成分を含む製品を製造しております。',
  },
  //豆乳とお野菜のマフィン（2個入り）
  {
    id: 7915325653246,
    title: '豆乳とお野菜のマフィン（2個入り）',
    handle: 'de-0012-001',
    description:
      'アレルゲン「卵」・「乳」不使用。豆乳でつくった生地に北海道産かぼちゃ、にんじん、青森県産りんごの果汁を加えたマフィンです。\nカップケーキ形状の焼き菓子で、冷凍庫から出して自然解凍するだけでお召しあがりいただけます。\nお子様にもぴったりなやさしい甘みとサイズ感で、食後のデザートやおやつなどでおたのしみください。',
    published_at: '2023-01-30T09:30:25+09:00',
    created_at: '2022-10-28T21:12:27+09:00',
    vendor: '食＋（ショクタス）公式オンラインショップ',
    type: '',
    tags: ['all', 'アレルゲン不使用', 'デザート', 'ビヨンドフリー', '卵・乳不使用'],
    price: 40000,
    price_min: 40000,
    price_max: 40000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 43652508811518,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7180004',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: '豆乳とお野菜のマフィン（2個入り）',
        public_title: null,
        options: ['Default Title'],
        price: 40000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: '',
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 38000,
              },
            ],
            price: 38000,
            compare_at_price: 40000,
            per_delivery_price: 38000,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 38000,
              },
            ],
            price: 38000,
            compare_at_price: 40000,
            per_delivery_price: 38000,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 38000,
              },
            ],
            price: 38000,
            compare_at_price: 40000,
            per_delivery_price: 38000,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0012-001_v1.png?v=1671547363',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0012-003.png?v=1674048895',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0012-001_v1.png?v=1671547363',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/de-0012-001',
    media: [
      {
        alt: null,
        id: 31479015014654,
        position: 1,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0012-001_v1.png?v=1671547363',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0012-001_v1.png?v=1671547363',
        width: 1500,
      },
      {
        alt: null,
        id: 31674245447934,
        position: 2,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0012-003.png?v=1674048895',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0012-003.png?v=1674048895',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回ご注文プラン', '2週に1回ご注文プラン', '4週に1回ご注文プラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回ご注文プラン',
            description: '週1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回ご注文プラン',
            description: '2週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回ご注文プラン',
            description: '4週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '2個',
      },
      {
        title: '原材料',
        content:
          '小麦粉（国内製造）、砂糖、豆乳、植物油脂、野菜（かぼちゃ、にんじん）、りんご濃縮果汁、食塩、パン酵母／加工デンプン、ソルビトール、乳化剤、ＨＰＭＣ、糊料（アルギン酸エステル、増粘多糖類）、炭酸Ｃａ、ベーキングパウダー、香料、（一部に小麦・大豆・りんごを含む）',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content: 'エネルギー 84kcal、たんぱく質 0.9g、脂質 3.9g、炭水化物 11.3g、食塩相当量 0.1g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: true,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: false,
          },
          {
            title: '乳成分',
            content: false,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: false,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: false,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: true,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: true,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },

      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約φ45㎜×約H27㎜ /約24g',
      },
      {
        title: 'お召し上がり方法',
        content: '室温（約25℃）で約30分解凍してください。',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上※パッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '※本品製造ラインでは卵・乳成分を含む製品を製造しております。',
    allergy_caution: '※本品製造ラインでは卵・乳成分を含む製品を製造しております。',
  },
  //糖質30％オフだけどおいしいうどん３食
  {
    id: 7915330175230,
    title: '糖質30％オフだけどおいしいうどん（３食入り）',
    handle: 'ud-0001-001',
    description:
      'おいしさをそのままに、糖質30％オフ（※）に仕上げたうどんです。\nこだわりの製法（大釜ゆで）、打ちたてのおいしさを閉じ込める急速冷凍で、讃岐うどんならではのコシと食感をおたのしみ頂けます。\n',
    published_at: '2023-01-30T09:27:00+09:00',
    created_at: '2022-10-28T21:17:25+09:00',
    vendor: '食＋（ショクタス）公式オンラインショップ',
    type: '',
    tags: ['all', 'うどん', 'ビヨンドフリー', '糖質カット', '糖質カット / 塩分カット', '麺'],
    price: 46000,
    price_min: 46000,
    price_max: 46000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 43652523852030,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7180038',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: '糖質30％オフだけどおいしいうどん（３食入り）',
        public_title: null,
        options: ['Default Title'],
        price: 46000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: '',
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 43700,
              },
            ],
            price: 43700,
            compare_at_price: 46000,
            per_delivery_price: 43700,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 43700,
              },
            ],
            price: 43700,
            compare_at_price: 46000,
            per_delivery_price: 43700,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 43700,
              },
            ],
            price: 43700,
            compare_at_price: 46000,
            per_delivery_price: 43700,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0001-001.png?v=1672108090',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0001-002.png?v=1674096088',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0001-003.png?v=1674096088',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0001-004.png?v=1676948658',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0001-001.png?v=1672108090',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/ud-0001-001',
    media: [
      {
        alt: '糖質30％オフだけどおいしいうどん３食',
        id: 31527087276286,
        position: 1,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0001-001.png?v=1672108090',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0001-001.png?v=1672108090',
        width: 1500,
      },
      {
        alt: null,
        id: 31679511527678,
        position: 2,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0001-002.png?v=1674096088',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0001-002.png?v=1674096088',
        width: 1500,
      },
      {
        alt: null,
        id: 31679512445182,
        position: 3,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0001-003.png?v=1674096088',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0001-003.png?v=1674096088',
        width: 1500,
      },
      {
        alt: null,
        id: 31872471662846,
        position: 4,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0001-004.png?v=1676948658',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0001-004.png?v=1676948658',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回ご注文プラン', '2週に1回ご注文プラン', '4週に1回ご注文プラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回ご注文プラン',
            description: '週1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回ご注文プラン',
            description: '2週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回ご注文プラン',
            description: '4週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '540グラム（3食）',
      },
      {
        title: '原材料',
        content:
          'めん〔小麦粉（国内製造）、小麦たん白、食塩、還元水あめ、植物油脂／加工デンプン、増粘剤（アルギン酸Na、アルギン酸エステル）〕',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content:
          'エネルギー 200kcal、たんぱく質 7.4g、脂質 1.4g、炭水化物 47.7g、 糖質 31.3g、 食物繊維 16.4g、食塩相当量 0.9g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: true,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: false,
          },
          {
            title: '乳成分',
            content: false,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: false,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: false,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: false,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: false,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },

      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約140㎜×約95㎜×約30㎜ / 180g',
      },
      {
        title: 'お召し上がり方法',
        content:
          '【鍋調理】①大きめの鍋でたっぷりのお湯を沸かし、内袋をはずした凍ったままのめんを入れます。 ②約1分ゆで、めんがほぐれたらお好みのつゆと具材でお召しあがりください。 ※調理時間は火力や鍋の大きさ等の違いで多少異なります。 【電子レンジ】 ①凍ったままのめんを内袋のままお皿にのせ、電子レンジで温めます。 ※調理時に内袋が破れてめんが飛び出ることがありますのでお皿を使用して温めてください。 ②やけどに注意して電子レンジからお皿ごと取り出し、お好みのつゆと具材でお召しあがりください。 ※内袋をはずす際に袋から蒸気が出ることがあります。 ＜500W＞約3分30秒 ＜600W＞約3分20秒',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上※パッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '',
    allergy_caution: '',
  },
  //糖質30％オフ お皿がいらないぶっかけ牛肉うどん
  {
    id: 7915330535678,
    title: '糖質30％オフ お皿がいらないぶっかけ牛肉うどん',
    handle: 'ud-0003-001',
    description:
      '簡単便利なトレー入り。糖質30％オフ（※）。\nもちもち食感のうどんに、だしの旨みがきいたつゆで甘辛く味付けした牛肉をトッピングしたぶっかけうどんです。\n※当社品お皿がいらないぶっかけ牛肉うどん100g当りでの比較',
    published_at: '2023-01-30T09:29:50+09:00',
    created_at: '2022-10-28T21:17:49+09:00',
    vendor: '食＋（ショクタス）公式オンラインショップ',
    type: '',
    tags: ['all', 'うどん', 'ビヨンドフリー', '糖質カット', '糖質カット / 塩分カット', '麺'],
    price: 49000,
    price_min: 49000,
    price_max: 49000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 43652524835070,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7180034',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: '糖質30％オフ お皿がいらないぶっかけ牛肉うどん',
        public_title: null,
        options: ['Default Title'],
        price: 49000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: null,
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0003-001.png?v=1672098705',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0003-002.png?v=1674088249',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0003-003.png?v=1674088249',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0003-001.png?v=1672098705',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/ud-0003-001',
    media: [
      {
        alt: '糖質30％オフ麺使用 お皿がいらないぶっかけ牛肉うどん',
        id: 31526625476862,
        position: 1,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0003-001.png?v=1672098705',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0003-001.png?v=1672098705',
        width: 1500,
      },
      {
        alt: null,
        id: 31678584914174,
        position: 2,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0003-002.png?v=1674088249',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0003-002.png?v=1674088249',
        width: 1500,
      },
      {
        alt: null,
        id: 31674241908990,
        position: 3,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0003-003.png?v=1674088249',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0003-003.png?v=1674088249',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回ご注文プラン', '2週に1回ご注文プラン', '4週に1回ご注文プラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回ご注文プラン',
            description: '週1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回ご注文プラン',
            description: '2週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回ご注文プラン',
            description: '4週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '273グラム',
      },
      {
        title: '原材料',
        content:
          'めん〔小麦粉（国内製造）、小麦たん白、食塩、還元水あめ、植物油脂／加工デンプン、増粘剤（アルギン酸Na、アルギン酸エステル）〕、牛肉、ねぎ、砂糖、しょうゆ、たん白加水分解物、食塩、風味調味料、ゼラチン、煮干エキス、かつお節エキス、煮干、かつお節粉末、かつお節、しいたけエキス、こんぶ、発酵調味料、酵母エキス／調味料（アミノ酸等）、増粘剤（加工デンプン、キサンタンガム）、トレハロース、重曹、カラメル色素、くん液、（一部に小麦・乳成分・牛肉・大豆・ゼラチンを含む）',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content:
          'エネルギー 285kcal、たんぱく質 13.9g、脂質 5.7g、炭水化物 54.1g、 糖質 35.0g、 食物繊維 19.1g、食塩相当量 3.5g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: true,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: false,
          },
          {
            title: '乳成分',
            content: true,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: false,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: true,
          },
          {
            title: 'ごま',
            content: false,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: true,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: false,
          },
          {
            title: 'ゼラチン',
            content: true,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },

      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約190㎜×約150㎜×約40㎜/273g',
      },
      {
        title: 'お召し上がり方法',
        content:
          '【電子レンジ専用】 ①外袋に２ｃｍほど切り込みを入れ、凍ったままの商品をラベルがある面を上にして、外袋のまま電子レンジで温めます。 ②外袋からトレーを取り出し、よく混ぜてお召しあがりください。 ※蒸気に注意して外袋の両端を持ち、中身がこぼれないように水平にして電子レンジから取り出してください。 ＜500W＞約6分 ＜600W＞約5分',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上※パッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '',
    allergy_caution: '',
  },
  //糖質30％オフ お皿がいらない明太クリームうどん
  {
    id: 7915330437374,
    title: '糖質30％オフ お皿がいらない明太クリームうどん',
    handle: 'ud-0002-001',
    description:
      '簡単便利なトレー入り。糖質30％オフ（※）。\nクリーミーな明太子のソースに、ほうれん草と、もちもち食感のうどんを合わせた明太クリームうどんです。\n※当社品お皿がいらない明太クリームうどん100ｇ当りでの比較',
    published_at: '2023-01-30T09:29:49+09:00',
    created_at: '2022-10-28T21:17:40+09:00',
    vendor: '食＋（ショクタス）公式オンラインショップ',
    type: '',
    tags: ['all', 'うどん', 'ビヨンドフリー', '糖質カット', '糖質カット / 塩分カット', '麺'],
    price: 49000,
    price_min: 49000,
    price_max: 49000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 43652524605694,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7180033',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: '糖質30％オフ お皿がいらない明太クリームうどん',
        public_title: null,
        options: ['Default Title'],
        price: 49000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: null,
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0002-001.png?v=1672098599',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0002-002.png?v=1674088187',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0002-003.png?v=1674088187',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0002-001.png?v=1672098599',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/ud-0002-001',
    media: [
      {
        alt: '糖質30％オフ麺使用 お皿がいらない明太クリームうどん',
        id: 31526617907454,
        position: 1,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0002-001.png?v=1672098599',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0002-001.png?v=1672098599',
        width: 1500,
      },
      {
        alt: null,
        id: 31678578786558,
        position: 2,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0002-002.png?v=1674088187',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0002-002.png?v=1674088187',
        width: 1500,
      },
      {
        alt: null,
        id: 31674238730494,
        position: 3,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0002-003.png?v=1674088187',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0002-003.png?v=1674088187',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回ご注文プラン', '2週に1回ご注文プラン', '4週に1回ご注文プラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回ご注文プラン',
            description: '週1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回ご注文プラン',
            description: '2週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回ご注文プラン',
            description: '4週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '258グラム',
      },
      {
        title: '原材料',
        content:
          'めん〔小麦粉（国内製造）、小麦たん白、食塩、還元水あめ、植物油脂／加工デンプン、増粘剤（アルギン酸Na、アルギン酸エステル）〕、牛乳、ほうれんそう、辛子めんたいこ、めんたいこ調味料、バター、クリーム、チキンエキス調味料、マーガリン、みそ、みりん、発酵調味料、粉糖、酵母エキス、たん白加水分解物／調味料（アミノ酸等）、増粘剤（加工デンプン、増粘多糖類）、トレハロース、乳化剤、着色料（紅麹、クチナシ、カロチノイド）、香料、発色剤（亜硝酸Na）、（一部に小麦・乳成分・大豆・鶏肉・ゼラチンを含む）',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content:
          'エネルギー 293kcal、たんぱく質 11.1g、脂質 8.0g、炭水化物 53.1g、 糖質 35.3g、 食物繊維 17.8g、食塩相当量 3.1g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: true,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: false,
          },
          {
            title: '乳成分',
            content: true,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: false,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: false,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: true,
          },
          {
            title: '鶏肉',
            content: true,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: false,
          },
          {
            title: 'ゼラチン',
            content: true,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },

      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約190㎜×約150㎜×約40㎜/258g',
      },
      {
        title: 'お召し上がり方法',
        content:
          '【電子レンジ専用】　①外袋に2cmほど切り込みを入れ、凍ったままの商品をラベルがある面を上にして、外袋のまま電子レンジで温めます。②外袋からトレーを取り出し、よく混ぜてお召しあがりください。 ※蒸気に注意して外袋の両端を持ち、中身がこぼれないように水平にして電子レンジから取り出してください。 ＜500W＞約5分30秒 ＜600W＞約4分40秒',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上※パッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '',
    allergy_caution: '',
  },
  //無塩食パン（2枚入り）
  {
    id: 7915331584254,
    title: '無塩食パン（2枚入り）',
    handle: 'be-0025-001',
    description:
      '食塩相当量0g。\n塩分を制限されている方にも安心して召しあがって頂ける食塩相当量0gの食パンです。使いやすい2枚入り個包装タイプです。',
    published_at: '2023-01-30T09:29:46+09:00',
    created_at: '2022-10-28T21:18:55+09:00',
    vendor: '食＋（ショクタス）公式オンラインショップ',
    type: '',
    tags: ['all', 'ベーカリー', '塩分カット', '糖質カット / 塩分カット'],
    price: 25000,
    price_min: 25000,
    price_max: 25000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 43652528996606,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7180013',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: '無塩食パン（2枚入り）',
        public_title: null,
        options: ['Default Title'],
        price: 25000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: null,
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 23800,
              },
            ],
            price: 23800,
            compare_at_price: 25000,
            per_delivery_price: 23800,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 23800,
              },
            ],
            price: 23800,
            compare_at_price: 25000,
            per_delivery_price: 23800,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 23800,
              },
            ],
            price: 23800,
            compare_at_price: 25000,
            per_delivery_price: 23800,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0025-001.png?v=1672099059',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0025-002.png?v=1674096201',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0025-003.png?v=1676855658',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0025-001.png?v=1672099059',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/be-0025-001',
    media: [
      {
        alt: '無塩食パン',
        id: 31526650511614,
        position: 1,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0025-001.png?v=1672099059',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0025-001.png?v=1672099059',
        width: 1500,
      },
      {
        alt: null,
        id: 31679525028094,
        position: 2,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0025-002.png?v=1674096201',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0025-002.png?v=1674096201',
        width: 1500,
      },
      {
        alt: null,
        id: 31866755449086,
        position: 3,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0025-003.png?v=1676855658',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0025-003.png?v=1676855658',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回ご注文プラン', '2週に1回ご注文プラン', '4週に1回ご注文プラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回ご注文プラン',
            description: '週1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回ご注文プラン',
            description: '2週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回ご注文プラン',
            description: '4週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '2枚',
      },
      {
        title: '原材料',
        content:
          '小麦粉（国内製造）、砂糖、マーガリン、イースト、乳等を主要原料とする食品、アセロラパウダー／乳化剤、香料、カロチノイド色素、（一部に小麦・乳成分・大豆を含む）',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content: 'エネルギー 262kcal、たんぱく質 7.9g、脂質 5.5g、炭水化物 45.3g、食塩相当量 0.0g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: true,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: false,
          },
          {
            title: '乳成分',
            content: true,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: false,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: false,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: true,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: false,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },

      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約120㎜×約115㎜×約28㎜ / 48g',
      },
      {
        title: 'お召し上がり方法',
        content: '室温（約25℃）で約30分解凍してください。',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上※パッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '※本品製造ラインでは卵を含む製品を製造しております。',
    allergy_caution: '',
  },
  //国産小麦 減塩だけどおいしいうどん３食
  {
    id: 7915330699518,
    title: '国産小麦 減塩だけどおいしいうどん（３食入り）',
    handle: 'ud-0004-001',
    description:
      '香り高い国産小麦粉を使用し、強いコシとなめらかな食感はそのままに、塩分を約50%オフ（※）。\nちょっと塩分が気になる方に最適です。\n\n※当社品さぬきうどん（3食入り）に対して1食分（180g）当たり食塩相当量50%カット',
    published_at: '2023-01-30T09:29:45+09:00',
    created_at: '2022-10-28T21:17:59+09:00',
    vendor: '食＋（ショクタス）公式オンラインショップ',
    type: '',
    tags: ['all', 'うどん', 'ビヨンドフリー', '塩分カット', '糖質カット / 塩分カット', '麺'],
    price: 46000,
    price_min: 46000,
    price_max: 46000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 43652525228286,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7180035',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: '国産小麦 減塩だけどおいしいうどん（３食入り）',
        public_title: null,
        options: ['Default Title'],
        price: 46000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: null,
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 43700,
              },
            ],
            price: 43700,
            compare_at_price: 46000,
            per_delivery_price: 43700,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 43700,
              },
            ],
            price: 43700,
            compare_at_price: 46000,
            per_delivery_price: 43700,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 43700,
              },
            ],
            price: 43700,
            compare_at_price: 46000,
            per_delivery_price: 43700,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0004-001.png?v=1672108055',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0004-002.png?v=1674096149',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0004-003.png?v=1674096149',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0004-004.png?v=1676948618',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0004-001.png?v=1672108055',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/ud-0004-001',
    media: [
      {
        alt: '国産小麦 減塩だけどおいしいうどん３食',
        id: 31527086129406,
        position: 1,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0004-001.png?v=1672108055',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0004-001.png?v=1672108055',
        width: 1500,
      },
      {
        alt: null,
        id: 31679517655294,
        position: 2,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0004-002.png?v=1674096149',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0004-002.png?v=1674096149',
        width: 1500,
      },
      {
        alt: null,
        id: 31679518310654,
        position: 3,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0004-003.png?v=1674096149',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0004-003.png?v=1674096149',
        width: 1500,
      },
      {
        alt: null,
        id: 31872469532926,
        position: 4,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0004-004.png?v=1676948618',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/UD-0004-004.png?v=1676948618',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回ご注文プラン', '2週に1回ご注文プラン', '4週に1回ご注文プラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回ご注文プラン',
            description: '週1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回ご注文プラン',
            description: '2週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回ご注文プラン',
            description: '4週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '540グラム（3食）',
      },
      {
        title: '原材料',
        content: 'めん〔小麦粉（国内製造）、食塩／加工デンプン〕',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content: 'エネルギー 228kcal、たんぱく質 5.8g、脂質 0.7g、炭水化物 49.7g、食塩相当量 0.4g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: true,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: false,
          },
          {
            title: '乳成分',
            content: false,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: false,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: false,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: false,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: false,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },

      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約160㎜×約95㎜×約30㎜ / 180g',
      },
      {
        title: 'お召し上がり方法',
        content:
          '【鍋調理】　内袋から出した凍ったままのめんを沸騰したお湯で約1分ゆでてください。　※調理時間は火力や鍋の大きさ等の違いで多少異なります。【電子レンジ】　①凍ったままのめんを内袋のままお皿にのせ、電子レンジで温めます。　※調理時に内袋が破れてめんが飛び出ることがありますのでお皿を使用して温めてください。　②やけどに注意して電子レンジからお皿ごと取り出し、お好みのつゆと具材でお召しあがりください。　※内袋をはずす際に袋から蒸気が出ることがあります。　※調理時間は商品の温度や電子レンジの機種等の違いで多少異なります。　※調理後も冷たい場合は追加で10秒ずつ温めてください。　＜500W＞約3分40秒　＜600W＞約3分20秒',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上※パッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '',
    allergy_caution: '',
  },
  //全粒粉ロール 糖質70%オフ（2個入り）
  {
    id: 7915329978622,
    title: '全粒粉ロール 糖質70%オフ（2個入り）',
    handle: 'be-0024-001',
    description:
      '大豆粉などを使用することで、糖質70％オフ（※）に仕上げたロールパンです。お食事やおやつなど、糖質が気になるさまざまな食シーンでおたのしみください。※日本食品標準成分表2022年版（八訂）ロールパンと比較（100g当たり）',
    published_at: '2023-01-30T09:03:57+09:00',
    created_at: '2022-10-28T21:17:16+09:00',
    vendor: '食＋（ショクタス）公式オンラインショップ',
    type: 'ベーカリー',
    tags: ['all', 'ビヨンドフリー', 'ベーカリー', '糖質カット', '糖質カット / 塩分カット'],
    price: 33000,
    price_min: 33000,
    price_max: 33000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 43652523491582,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7180012',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: '全粒粉ロール 糖質70%オフ（2個入り）',
        public_title: null,
        options: ['Default Title'],
        price: 33000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: '7610988',
        quantity_rule: {
          min: 1,
          max: null,
          increment: 1,
        },
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 31400,
              },
            ],
            price: 31400,
            compare_at_price: 33000,
            per_delivery_price: 31400,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 31400,
              },
            ],
            price: 31400,
            compare_at_price: 33000,
            per_delivery_price: 31400,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 31400,
              },
            ],
            price: 31400,
            compare_at_price: 33000,
            per_delivery_price: 31400,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0024-001.png?v=1672098498',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0024-002.png?v=1674088876',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0024-003.png?v=1674088876',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0024-001.png?v=1672098498',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/be-0024-001',
    media: [
      {
        alt: '全粒粉ロール 糖質70%オフ',
        id: 31526612631806,
        position: 1,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0024-001.png?v=1672098498',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0024-001.png?v=1672098498',
        width: 1500,
      },
      {
        alt: null,
        id: 31678659231998,
        position: 2,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0024-002.png?v=1674088876',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0024-002.png?v=1674088876',
        width: 1500,
      },
      {
        alt: null,
        id: 31674231193854,
        position: 3,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0024-003.png?v=1674088876',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0024-003.png?v=1674088876',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回ご注文プラン', '2週に1回ご注文プラン', '4週に1回ご注文プラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回ご注文プラン',
            description: '週1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回ご注文プラン',
            description: '2週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回ご注文プラン',
            description: '4週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '2個',
      },
      {
        title: '原材料',
        content:
          '小麦グルテン（国内製造）、還元難消化性デキストリン、小麦全粒粉、大豆粉、全卵、マーガリン、小麦粉、乳等を主要原料とする食品、イースト、食塩／増粘剤（グァーガム）、乳化剤、甘味料（アスパルテーム・L-フェニルアラニン化合物）、（一部に小麦・卵・乳成分・大豆を含む）',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content:
          'エネルギー 159kcal、たんぱく質 12.4g、脂質 6.5g、炭水化物 17.8g、 糖質 7.4g、 食物繊維 10.4g、食塩相当量 0.8g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: true,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: true,
          },
          {
            title: '乳成分',
            content: true,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: false,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: false,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: true,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: false,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },

      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約φ60㎜×約H45㎜ /30g',
      },
      {
        title: 'お召し上がり方法',
        content: '袋のまま室温（約25℃）で約３時間解凍してください。',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上※パッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '※本品製造ラインではごまを含む製品を製造しております。',
    allergy_caution: '',
  },
  //ライスバーガー 大豆ミート 生姜焼き味
  {
    id: 7915329093886,
    title: 'ライスバーガー 大豆ミート 生姜焼き味',
    handle: 'cr-0002-001',
    description:
      '動物性原材料不使用。\n表面はカリッと、中はふっくら仕上げた醤油味のライスバンズで、醤油、生姜、ニンニクを効かせたあっさり生姜ダレで味付けした大豆ミートを挟んだ、生姜焼き味のプラントベースライスバーガーです。',
    published_at: '2023-01-30T09:03:56+09:00',
    created_at: '2022-10-28T21:16:23+09:00',
    vendor: '食＋（ショクタス）公式オンラインショップ',
    type: '',
    tags: ['all', 'ご飯もの', '動物性原材料不使用'],
    price: 40000,
    price_min: 40000,
    price_max: 40000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 43652520968446,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7180031',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: 'ライスバーガー 大豆ミート 生姜焼き味',
        public_title: null,
        options: ['Default Title'],
        price: 40000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: '',
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 38000,
              },
            ],
            price: 38000,
            compare_at_price: 40000,
            per_delivery_price: 38000,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 38000,
              },
            ],
            price: 38000,
            compare_at_price: 40000,
            per_delivery_price: 38000,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 38000,
              },
            ],
            price: 38000,
            compare_at_price: 40000,
            per_delivery_price: 38000,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0002-001.png?v=1672107064',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0002-002.png?v=1674089945',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0002-003.png?v=1674089945',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0002-004.png?v=1674089945',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0002-005.png?v=1676855740',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/what_s-plant-based_d6200bc1-b6e4-40cf-9b02-4f8b7bb98609.png?v=1676855740',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0002-001.png?v=1672107064',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/cr-0002-001',
    media: [
      {
        alt: 'ライスバーガー 大豆ミート 生姜焼き',
        id: 31527056933118,
        position: 1,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0002-001.png?v=1672107064',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0002-001.png?v=1672107064',
        width: 1500,
      },
      {
        alt: null,
        id: 31678784209150,
        position: 2,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0002-002.png?v=1674089945',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0002-002.png?v=1674089945',
        width: 1500,
      },
      {
        alt: null,
        id: 31664392667390,
        position: 3,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0002-003.png?v=1674089945',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0002-003.png?v=1674089945',
        width: 1500,
      },
      {
        alt: null,
        id: 31664393355518,
        position: 4,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0002-004.png?v=1674089945',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0002-004.png?v=1674089945',
        width: 1500,
      },
      {
        alt: null,
        id: 31866762068222,
        position: 5,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0002-005.png?v=1676855740',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0002-005.png?v=1676855740',
        width: 1500,
      },
      {
        alt: null,
        id: 31799596155134,
        position: 6,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/what_s-plant-based_d6200bc1-b6e4-40cf-9b02-4f8b7bb98609.png?v=1676855740',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/what_s-plant-based_d6200bc1-b6e4-40cf-9b02-4f8b7bb98609.png?v=1676855740',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回ご注文プラン', '2週に1回ご注文プラン', '4週に1回ご注文プラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回ご注文プラン',
            description: '週1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回ご注文プラン',
            description: '2週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回ご注文プラン',
            description: '4週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '1個',
      },
      {
        title: '原材料',
        content:
          'ライスプレート〔うるち米（国内産）、しょうゆ、植物油脂、みりん、でん粉、大豆多糖類、食塩〕、しょうゆ、たまねぎ、大豆たん白食品、植物油脂、砂糖、りんごピューレ、みりん、発酵調味料、おろししょうが、おろしにんにく、たまねぎ加工品、しょうが汁／増粘剤（加工デンプン、増粘多糖類）、トレハロース、調味料（アミノ酸）、カラメル色素、酸味料、（一部に小麦・大豆・りんごを含む）',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content: 'エネルギー 240kcal、たんぱく質 6.1g、脂質 3.4g、炭水化物 46.2g、食塩相当量 1.5g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: true,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: false,
          },
          {
            title: '乳成分',
            content: false,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: false,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: false,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: true,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: true,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },

      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約106㎜×約120㎜×約39㎜ / 135g',
      },
      {
        title: 'お召し上がり方法',
        content:
          '【電子レンジ】　①凍ったままの商品を外袋から取り出します。　内袋の端に2ｃｍほど切り込みを入れてから電子レンジで温めてください。　＜500W＞約3分20秒　＜600W＞約3分00秒　②内袋の両端を持って電子レンジから取り出し、切り込みから内袋を切ってお召しあがりください。　※調理後、商品を取り出す際は、やけどにご注意ください。',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上※パッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '',
    allergy_caution: '',
  },
  //ライスバーガー 大豆ミート 焼肉味
  {
    id: 7915328602366,
    title: 'ライスバーガー 大豆ミート 焼肉味',
    handle: 'cr-0001-001',
    description:
      '動物性原材料不使用。\n表面はカリッと、中はふっくら仕上げた醤油味のライスバンズで、醤油、コチジャン、豆板醤、りんごピューレなどで味付けした大豆ミートを挟んだ、焼肉味のプラントベースライスバーガーです。',
    published_at: '2023-01-30T09:03:54+09:00',
    created_at: '2022-10-28T21:16:03+09:00',
    vendor: '食＋（ショクタス）公式オンラインショップ',
    type: '',
    tags: ['all', 'ご飯もの', 'ビヨンドフリー', '動物性原材料不使用'],
    price: 40000,
    price_min: 40000,
    price_max: 40000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 43652519559422,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7180030',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: 'ライスバーガー 大豆ミート 焼肉味',
        public_title: null,
        options: ['Default Title'],
        price: 40000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: '',
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 38000,
              },
            ],
            price: 38000,
            compare_at_price: 40000,
            per_delivery_price: 38000,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 38000,
              },
            ],
            price: 38000,
            compare_at_price: 40000,
            per_delivery_price: 38000,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 38000,
              },
            ],
            price: 38000,
            compare_at_price: 40000,
            per_delivery_price: 38000,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0001-001.png?v=1672106992',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0001-002.png?v=1674089907',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0001-003.png?v=1674089907',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0001-004.png?v=1674089907',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0001-005.png?v=1676855810',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/what_s-plant-based_4f0660f3-94ec-4e42-9f87-e74b98eb629f.png?v=1676855810',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0001-001.png?v=1672106992',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/cr-0001-001',
    media: [
      {
        alt: 'ライスバーガー 大豆ミート 焼肉',
        id: 31527052017918,
        position: 1,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0001-001.png?v=1672106992',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0001-001.png?v=1672106992',
        width: 1500,
      },
      {
        alt: null,
        id: 31678779097342,
        position: 2,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0001-002.png?v=1674089907',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0001-002.png?v=1674089907',
        width: 1500,
      },
      {
        alt: null,
        id: 31664390832382,
        position: 3,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0001-003.png?v=1674089907',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0001-003.png?v=1674089907',
        width: 1500,
      },
      {
        alt: null,
        id: 31664391160062,
        position: 4,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0001-004.png?v=1674089907',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0001-004.png?v=1674089907',
        width: 1500,
      },
      {
        alt: null,
        id: 31866765050110,
        position: 5,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0001-005.png?v=1676855810',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0001-005.png?v=1676855810',
        width: 1500,
      },
      {
        alt: null,
        id: 31799594746110,
        position: 6,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/what_s-plant-based_4f0660f3-94ec-4e42-9f87-e74b98eb629f.png?v=1676855810',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/what_s-plant-based_4f0660f3-94ec-4e42-9f87-e74b98eb629f.png?v=1676855810',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回ご注文プラン', '2週に1回ご注文プラン', '4週に1回ご注文プラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回ご注文プラン',
            description: '週1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回ご注文プラン',
            description: '2週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回ご注文プラン',
            description: '4週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '1個',
      },
      {
        title: '原材料',
        content:
          'ライスプレート〔うるち米（国内産）、しょうゆ、植物油脂、みりん、でん粉、大豆多糖類、食塩〕、しょうゆ、たまねぎ、粒状植物性たん白、植物油脂、りんごピューレ、砂糖、発酵調味料、水あめ、みりん、おろしにんにく、コチジャン、たまねぎ加工品、おろししょうが、りんご濃縮果汁、食塩、豆板醤／増粘剤（加工デンプン、増粘多糖類）、調味料（アミノ酸等）、カラメル色素、トレハロース、酸味料、（一部に小麦・大豆・りんごを含む）',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content: 'エネルギー 242kcal、たんぱく質 5.8g、脂質 3.4g、炭水化物 47.0g、食塩相当量 1.7g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: true,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: false,
          },
          {
            title: '乳成分',
            content: false,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: false,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: false,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: true,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: true,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },

      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約106㎜×約120㎜×約39㎜ / 135g',
      },
      {
        title: 'お召し上がり方法',
        content:
          '【電子レンジ】　①凍ったままの商品を外袋から取り出します。　内袋の端に2ｃｍほど切り込みを入れてから電子レンジで温めてください。　＜500W＞約3分20秒　＜600W＞約3分00秒　②内袋の両端を持って電子レンジから取り出し、切り込みから内袋を切ってお召しあがりください。　※調理後、商品を取り出す際は、やけどにご注意ください',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上※パッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '',
    allergy_caution: '',
  },
  //ライスバーガー プレーンバンズ 4個入り
  {
    id: 7915329159422,
    title: 'ライスバーガー プレーンバンズ（4枚入り）',
    handle: 'cr-0003-001',
    description:
      '表面はカリッと、中はふっくら仕上げた醤油味のライスバンズ（4枚入り）です。\nお好みで具材を挟んで頂くことで、オリジナルライスバーガー用のバンズとしておたのしみ頂けます。',
    published_at: '2023-01-30T09:03:52+09:00',
    created_at: '2022-10-28T21:16:33+09:00',
    vendor: '食＋（ショクタス）公式オンラインショップ',
    type: '',
    tags: ['all', 'ご飯もの', 'ビヨンドフリー', '動物性原材料不使用'],
    price: 33000,
    price_min: 33000,
    price_max: 33000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 43652521099518,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7180032',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: 'ライスバーガー プレーンバンズ（4枚入り）',
        public_title: null,
        options: ['Default Title'],
        price: 33000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: null,
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 31400,
              },
            ],
            price: 31400,
            compare_at_price: 33000,
            per_delivery_price: 31400,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 31400,
              },
            ],
            price: 31400,
            compare_at_price: 33000,
            per_delivery_price: 31400,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 31400,
              },
            ],
            price: 31400,
            compare_at_price: 33000,
            per_delivery_price: 31400,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0003-001.png?v=1672107114',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0003-002.png?v=1674089030',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/what_s-plant-based_7aadcc09-ef66-4eb4-bd20-97fdca1e0e24.png?v=1676614172',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0003-001.png?v=1672107114',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/cr-0003-001',
    media: [
      {
        alt: 'ライスバーガー プレーンバンズ 4個入り',
        id: 31527058538750,
        position: 1,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0003-001.png?v=1672107114',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0003-001.png?v=1672107114',
        width: 1500,
      },
      {
        alt: null,
        id: 31678678335742,
        position: 2,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0003-002.png?v=1674089030',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0003-002.png?v=1674089030',
        width: 1500,
      },
      {
        alt: null,
        id: 31850993287422,
        position: 3,
        preview_image: {
          aspect_ratio: 1.0,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/what_s-plant-based_7aadcc09-ef66-4eb4-bd20-97fdca1e0e24.png?v=1676614172',
        },
        aspect_ratio: 1.0,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/what_s-plant-based_7aadcc09-ef66-4eb4-bd20-97fdca1e0e24.png?v=1676614172',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回ご注文プラン', '2週に1回ご注文プラン', '4週に1回ご注文プラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回ご注文プラン',
            description: '週1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回ご注文プラン',
            description: '2週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回ご注文プラン',
            description: '4週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '4枚',
      },
      {
        title: '原材料',
        content:
          'うるち米（国内産）、しょうゆ、植物油脂、みりん、でん粉、大豆多糖類、食塩／トレハロース、カラメル色素、増粘剤（加工デンプン）、酸味料、（一部に小麦・大豆を含む）',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content: 'エネルギー 89kcal、たんぱく質 1.4g、脂質 0.7g、炭水化物 19.3g、食塩相当量 0.08g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: true,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: false,
          },
          {
            title: '乳成分',
            content: false,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: false,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: false,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: true,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: false,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },

      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約105㎜×約102㎜×約18㎜ / 50g',
      },
      {
        title: 'お召し上がり方法',
        content:
          '【電子レンジ専用】　凍ったままの商品を袋から取り出し、耐熱皿にのせてラップをかけずに加熱してください。　※調理後、商品を取り出す際は、やけどにご注意ください。　※袋のまま電子レンジで加熱しないでください。　＜500W＞2個：約2分　4個：約3分50秒　＜600W＞2個：約1分40秒　4個：約3分10秒',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上※パッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '',
    allergy_caution: '',
  },
  //こんにゃく米とお米で作った炒飯
  {
    id: 7915329421566,
    title: 'こんにゃく米とお米で作った炒飯',
    handle: 'cr-0004-001',
    description:
      'こんにゃく米を25％配合し、カロリーを32%カット（※）したヘルシーな炒飯です。具材には「おからこんにゃく」で作った卵・ハムチャーシューを採用し、動物性原材料を使用していません。レンジでチンするだけの簡単調理で、こんにゃく米の食感が新しい本格炒飯の味わいをお楽しみいただけます。（※）日本食品標準成分表（八訂）増補2023年　チャーハンと比較（100g当たり）',
    published_at: '2023-11-08T10:56:17+09:00',
    created_at: '2022-10-28T21:16:43+09:00',
    vendor: '食＋（ショクタス）公式オンラインショップ',
    type: '',
    tags: ['all', 'ご飯もの', 'アレルゲン不使用', 'ビヨンドフリー', '動物性原材料不使用', '卵・乳不使用'],
    price: 49000,
    price_min: 49000,
    price_max: 49000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 43652522213630,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7180029',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: 'こんにゃく米とお米で作った炒飯',
        public_title: null,
        options: ['Default Title'],
        price: 49000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: '',
        quantity_rule: {
          min: 1,
          max: null,
          increment: 1,
        },
        quantity_price_breaks: [],
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/2_d30e5f0c-a474-4cb8-9907-9f0c04a612aa.png?v=1699605594',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0004-002.png?v=1699605594',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0004-003.png?v=1699605594',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-8_a4491cb7-be5e-44b5-a1de-4ec7d002ba15.png?v=1699605594',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-2_0dcb79e6-7b11-449f-9466-eee3be1c8bd8.png?v=1699605594',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_b5483b64-32c0-4bdb-a289-65dde956f955_1.png?v=1699605594',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/what_s-plant-based_c606c713-baee-49d8-875c-dc1a77809fbe.png?v=1699605594',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/files/2_d30e5f0c-a474-4cb8-9907-9f0c04a612aa.png?v=1699605594',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/cr-0004-001',
    media: [
      {
        alt: null,
        id: 33052788916478,
        position: 1,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/2_d30e5f0c-a474-4cb8-9907-9f0c04a612aa.png?v=1699605594',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/2_d30e5f0c-a474-4cb8-9907-9f0c04a612aa.png?v=1699605594',
        width: 1500,
      },
      {
        alt: null,
        id: 31678993596670,
        position: 2,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0004-002.png?v=1699605594',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0004-002.png?v=1699605594',
        width: 1500,
      },
      {
        alt: null,
        id: 31674201932030,
        position: 3,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0004-003.png?v=1699605594',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/CR-0004-003.png?v=1699605594',
        width: 1500,
      },
      {
        alt: null,
        id: 33002911432958,
        position: 4,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-8_a4491cb7-be5e-44b5-a1de-4ec7d002ba15.png?v=1699605594',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-8_a4491cb7-be5e-44b5-a1de-4ec7d002ba15.png?v=1699605594',
        width: 1500,
      },
      {
        alt: null,
        id: 33002911465726,
        position: 5,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-2_0dcb79e6-7b11-449f-9466-eee3be1c8bd8.png?v=1699605594',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-2_0dcb79e6-7b11-449f-9466-eee3be1c8bd8.png?v=1699605594',
        width: 1500,
      },
      {
        alt: null,
        id: 33030526107902,
        position: 6,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_b5483b64-32c0-4bdb-a289-65dde956f955_1.png?v=1699605594',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_b5483b64-32c0-4bdb-a289-65dde956f955_1.png?v=1699605594',
        width: 1500,
      },
      {
        alt: null,
        id: 32159744852222,
        position: 7,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/what_s-plant-based_c606c713-baee-49d8-875c-dc1a77809fbe.png?v=1699605594',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/what_s-plant-based_c606c713-baee-49d8-875c-dc1a77809fbe.png?v=1699605594',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回ご注文プラン', '2週に1回ご注文プラン', '4週に1回ご注文プラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回ご注文プラン',
            description: '週1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回ご注文プラン',
            description: '2週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回ご注文プラン',
            description: '4週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '250グラム',
      },
      {
        title: '原材料',
        content:
          '粒こんにゃく（国内製造）、うるち米（国内産）、おからこんにゃく（植物油脂、おから、こんにゃく粉）、野菜（にんじん、たまねぎ、ねぎ）、植物油脂、おからこんにゃく（おから、こんにゃく粉）、しょうゆ、食塩、香味油、たん白加水分解物、砂糖、酵母エキス、みりん、香辛料、大豆多糖類、発酵調味料、オニオンエキスパウダー、還元水あめ／加工デンプン、トレハロース、水酸化Ca、酸味料、調味料（核酸）、香辛料抽出物、着色料（カロチノイド、カラメル）、pH調整剤、（一部に小麦・大豆を含む）',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content: 'エネルギー 348kcal　たんぱく質 5.5g　脂質 10.5g　炭水化物 57.8g　食塩相当量 4.2g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: true,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: false,
          },
          {
            title: '乳成分',
            content: false,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: false,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: false,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: true,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: false,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },

      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約130㎜×約210㎜×約25㎜ / 250g',
      },
      {
        title: 'お召し上がり方法',
        content:
          '【電子レンジ】　凍ったままの商品をお皿に盛り、中央部分をくぼませ、ラップをかけずに加熱してください。<br>＜600W＞約4分30秒<br>＜500W＞約5分20秒',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上※パッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '※本品製造工場では卵・乳成分を含む製品を生産しています。',
    allergy_caution: '※本品製造工場では卵・乳成分を含む製品を生産しています。',
  },
  //こっぺぱん
  {
    id: 7915326046462,
    title: 'こっぺぱん',
    handle: 'be-0026-001',
    description:
      '動物性原材料不使用。\nシンプルで飽きの来ない昔ながらのこっぺぱん。どんな料理とも相性が良いので食事パンとして、また揚げパンなどのアレンジでおやつとしてもおたのしみ頂けます。',
    published_at: '2023-01-30T09:03:50+09:00',
    created_at: '2022-10-28T21:12:56+09:00',
    vendor: '食＋（ショクタス）公式オンラインショップ',
    type: '',
    tags: ['all', 'ベーカリー', '動物性原材料不使用'],
    price: 25000,
    price_min: 25000,
    price_max: 25000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 43652509860094,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7180005',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: 'こっぺぱん',
        public_title: null,
        options: ['Default Title'],
        price: 25000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: '',
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 23800,
              },
            ],
            price: 23800,
            compare_at_price: 25000,
            per_delivery_price: 23800,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 23800,
              },
            ],
            price: 23800,
            compare_at_price: 25000,
            per_delivery_price: 23800,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 23800,
              },
            ],
            price: 23800,
            compare_at_price: 25000,
            per_delivery_price: 23800,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0026-001.png?v=1672098905',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0026-002.png?v=1674088518',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0026-003.png?v=1674088518',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0026-001.png?v=1672098905',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/be-0026-001',
    media: [
      {
        alt: 'こっぺパン',
        id: 31526638125310,
        position: 1,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0026-001.png?v=1672098905',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0026-001.png?v=1672098905',
        width: 1500,
      },
      {
        alt: null,
        id: 31678618665214,
        position: 2,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0026-002.png?v=1674088518',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0026-002.png?v=1674088518',
        width: 1500,
      },
      {
        alt: null,
        id: 31674290700542,
        position: 3,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0026-003.png?v=1674088518',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/BE-0026-003.png?v=1674088518',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回ご注文プラン', '2週に1回ご注文プラン', '4週に1回ご注文プラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回ご注文プラン',
            description: '週1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回ご注文プラン',
            description: '2週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回ご注文プラン',
            description: '4週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '1個',
      },
      {
        title: '原材料',
        content: '小麦粉（国内製造）、砂糖、ショートニング、イースト、食塩、アセロラパウダー、（一部に小麦を含む）',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content: 'エネルギー 201kcal、たんぱく質 5.9g、脂質 4.6g、炭水化物 33.8g、食塩相当量 0.6g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: true,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: false,
          },
          {
            title: '乳成分',
            content: false,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: false,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: false,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: false,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: false,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },

      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約170㎜×約68㎜×約43㎜ / 約68g',
      },
      {
        title: 'お召し上がり方法',
        content: '袋のまま室温（約25℃）で約３時間解凍してください。',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上※パッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '※本品製造ラインでは卵・乳成分を含む製品を製造しております。',
    allergy_caution: '',
  },
  //おからこんにゃくで作った カツ
  {
    id: 8201800089854,
    title: 'おからこんにゃくで作った カツ',
    handle: 'si-0002-001',
    description:
      '豆乳を搾る際の副産物「おから」と日本の伝統食である「こんにゃく」を組み合わせた『おからこんにゃく』で作った動物性原材料不使用のカツです。おかずの一品としても満足頂けるよう食べ応えのあるしっかりとした食感のカツに仕上げました。',
    published_at: '2023-12-01T10:38:42+09:00',
    created_at: '2023-11-30T14:54:47+09:00',
    vendor: '食＋（ショクタス）公式オンラインショップ',
    type: '',
    tags: ['all', 'おかず', 'アレルゲン不使用', 'ビヨンドフリー', 'プラントベース', '動物性原材料不使用'],
    price: 49000,
    price_min: 49000,
    price_max: 49000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 44461978222846,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7180037',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: 'おからこんにゃくで作った カツ',
        public_title: null,
        options: ['Default Title'],
        price: 49000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: null,
        quantity_rule: {
          min: 1,
          max: null,
          increment: 1,
        },
        quantity_price_breaks: [],
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/1_3aaec5c4-0cd9-4205-9f76-d8a5eed469bd.png?v=1701323697',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/SI-0002-002_24c3a32c-35aa-4ba0-b770-c870629a0a80.png?v=1701323699',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/SI-0002-003_a39938be-8a8f-47c5-864d-33201d1bd00b.png?v=1701323698',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/what_s-plant-based_6c96de4f-61e2-4dfa-a425-342968a01437.png?v=1701323697',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_1.png?v=1701323697',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/files/1_3aaec5c4-0cd9-4205-9f76-d8a5eed469bd.png?v=1701323697',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/si-0002-001',
    media: [
      {
        alt: null,
        id: 33162356949246,
        position: 1,
        preview_image: {
          aspect_ratio: 1,
          height: 1181,
          width: 1181,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1_3aaec5c4-0cd9-4205-9f76-d8a5eed469bd.png?v=1701323697',
        },
        aspect_ratio: 1,
        height: 1181,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1_3aaec5c4-0cd9-4205-9f76-d8a5eed469bd.png?v=1701323697',
        width: 1181,
      },
      {
        alt: null,
        id: 33162356982014,
        position: 2,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/SI-0002-002_24c3a32c-35aa-4ba0-b770-c870629a0a80.png?v=1701323699',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/SI-0002-002_24c3a32c-35aa-4ba0-b770-c870629a0a80.png?v=1701323699',
        width: 1500,
      },
      {
        alt: null,
        id: 33162357014782,
        position: 3,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/SI-0002-003_a39938be-8a8f-47c5-864d-33201d1bd00b.png?v=1701323698',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/SI-0002-003_a39938be-8a8f-47c5-864d-33201d1bd00b.png?v=1701323698',
        width: 1500,
      },
      {
        alt: null,
        id: 33162357047550,
        position: 4,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/what_s-plant-based_6c96de4f-61e2-4dfa-a425-342968a01437.png?v=1701323697',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/what_s-plant-based_6c96de4f-61e2-4dfa-a425-342968a01437.png?v=1701323697',
        width: 1500,
      },
      {
        alt: null,
        id: 33162357080318,
        position: 5,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_1.png?v=1701323697',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_1.png?v=1701323697',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回ご注文プラン', '2週に1回ご注文プラン', '4週に1回ご注文プラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回ご注文プラン',
            description: '週1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回ご注文プラン',
            description: '2週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回ご注文プラン',
            description: '4週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '2個入り／100g',
      },
      {
        title: '原材料',
        content:
          'おからこんにゃく（植物油脂、おから、こんにゃく粉）、清酒、食塩、砂糖、酵母エキス加工品、香辛料、衣(パン粉、小麦粉、食塩、植物油脂、粉末油脂、小麦たん白、粉末酵母エキス)、揚げ油（大豆油）／加工デンプン、調味料（アミノ酸等）、水酸化Ｃａ、ｐＨ調整剤、膨張剤、カロチノイド色素、香料、（一部に小麦・ごま・大豆を含む）',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content: 'エネルギー 289kcal、たんぱく質 3.9g、脂質 18.8g、炭水化物 26.0g、食塩相当量 1.4g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: true,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: false,
          },
          {
            title: '乳成分',
            content: false,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: false,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: true,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: true,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: false,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },

      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約70㎜×約40㎜×約20㎜ / 約50g',
      },
      {
        title: 'お召し上がり方法',
        content:
          '①凍ったままの商品を袋から取り出し、お皿にのせます。<br>②ラップをかけずに電子レンジで温めてください。<br>＜500W＞1個：約1分　2個：約1分50秒<br>＜600W＞1個：約50秒　2個：約1分30秒',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上※パッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '※本品製造工場では卵・乳成分を含む製品を生産しています。',
    allergy_caution: '※本品製造工場では卵・乳成分を含む製品を生産しています。',
  },
  //おからこんにゃくで作った からあげ
  {
    id: 8211270893822,
    title: 'おからこんにゃくで作った からあげ',
    handle: 'si-0003-001',
    description:
      '豆乳を搾る際の副産物「おから」と日本の伝統食である「こんにゃく」を組み合わせた『おからこんにゃく』で作った動物性原材料不使用のからあげです。おかずの一品としても満足頂けるよう、和風ベースで飽きの来ない、ジューシーな味わいに仕上げました。',
    published_at: '2023-12-15T10:11:51+09:00',
    created_at: '2023-12-12T16:45:32+09:00',
    vendor: '食＋（ショクタス）公式オンラインショップ',
    type: '',
    tags: ['all', 'おかず', 'アレルゲン不使用', 'ビヨンドフリー', '動物性原材料不使用'],
    price: 49000,
    price_min: 49000,
    price_max: 49000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 44491960451326,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7180036',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: 'おからこんにゃくで作った からあげ',
        public_title: null,
        options: ['Default Title'],
        price: 49000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: '7180036',
        quantity_rule: {
          min: 1,
          max: null,
          increment: 1,
        },
        quantity_price_breaks: [],
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/5_d2d34a72-3ec7-4dbe-af99-43c7ab045c6a.png?v=1702367135',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/6_bac2be6a-0939-41d8-bdcd-00c968fbc4e3.png?v=1702367138',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/5_5ecd2dae-864c-4d68-a9c7-d748b300030e.png?v=1702367140',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/what_s-plant-based_792fa52a-27ee-4fda-b40e-33fa9bc2d499.png?v=1702367143',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/files/5_d2d34a72-3ec7-4dbe-af99-43c7ab045c6a.png?v=1702367135',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/si-0003-001',
    media: [
      {
        alt: null,
        id: 33227216814334,
        position: 1,
        preview_image: {
          aspect_ratio: 1,
          height: 945,
          width: 945,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/5_d2d34a72-3ec7-4dbe-af99-43c7ab045c6a.png?v=1702367135',
        },
        aspect_ratio: 1,
        height: 945,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/5_d2d34a72-3ec7-4dbe-af99-43c7ab045c6a.png?v=1702367135',
        width: 945,
      },
      {
        alt: null,
        id: 33227217043710,
        position: 2,
        preview_image: {
          aspect_ratio: 1,
          height: 945,
          width: 945,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/6_bac2be6a-0939-41d8-bdcd-00c968fbc4e3.png?v=1702367138',
        },
        aspect_ratio: 1,
        height: 945,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/6_bac2be6a-0939-41d8-bdcd-00c968fbc4e3.png?v=1702367138',
        width: 945,
      },
      {
        alt: null,
        id: 33227217273086,
        position: 3,
        preview_image: {
          aspect_ratio: 1,
          height: 945,
          width: 945,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/5_5ecd2dae-864c-4d68-a9c7-d748b300030e.png?v=1702367140',
        },
        aspect_ratio: 1,
        height: 945,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/5_5ecd2dae-864c-4d68-a9c7-d748b300030e.png?v=1702367140',
        width: 945,
      },
      {
        alt: null,
        id: 33227217567998,
        position: 4,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/what_s-plant-based_792fa52a-27ee-4fda-b40e-33fa9bc2d499.png?v=1702367143',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/what_s-plant-based_792fa52a-27ee-4fda-b40e-33fa9bc2d499.png?v=1702367143',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回ご注文プラン', '2週に1回ご注文プラン', '4週に1回ご注文プラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回ご注文プラン',
            description: '週1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回ご注文プラン',
            description: '2週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回ご注文プラン',
            description: '4週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '100グラム',
      },
      {
        title: '原材料',
        content:
          'おからこんにゃく（植物油脂、おから、こんにゃく粉）、しょうゆ、砂糖、清酒、野菜（しょうが、にんにく）、植物油脂、食塩、酵母エキス加工品、香辛料、衣(小麦粉、でん粉、植物油脂、ぶどう糖、食塩、粉末しょうゆ、香辛料)、揚げ油（大豆油）／加工デンプン、調味料（アミノ酸）、水酸化Ｃａ、ｐＨ調整剤、香料、（一部に小麦・大豆を含む）',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content: 'エネルギー 240kcal、たんぱく質 3.8g、脂質 14.1g、炭水化物 24.5g、食塩相当量 1.7g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: true,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: false,
          },
          {
            title: '乳成分',
            content: false,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: false,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: false,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: true,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: false,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },

      {
        title: '商品の大きさ / 重量（1個当たり）',
        content:
          '約40㎜×約35㎜×約25㎜ / 約17g<br>※この製品はパック重量で管理しているため、1個あたりの大きさ、重量にはばらつきがあります。',
      },
      {
        title: 'お召し上がり方法',
        content:
          '①凍ったままの商品を袋から取り出し、お皿にのせます。<br>②ラップをかけずに電子レンジで温めてください。<br>＜500W＞約1分30秒<br>＜600W＞約1分20秒',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上 ※パッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '※本品製造工場では卵・乳成分を含む製品を生産しています。',
    allergy_caution: '※本品製造工場では卵・乳成分を含む製品を生産しています。',
  },
  //玄米ブレッド プレーン
  {
    id: 8082964513022,
    title: '玄米ブレッド プレーン',
    handle: 'be-0028-001',
    description:
      'アレルギー特定原材料等28品目不使用。白米と比べて栄養価の高い玄米（熊本県産）を丸ごとペーストにして使用し、丁寧に焼き上げたキューブ形状のパンです。ふんわり、しっとり、もっちりとした食感に加え、素材由来のおいしさそのままに、玄米のほのかな香りと甘みをお楽しみいただけるプレーンタイプです。トースターで温めると、玄米の特性上、外側の生地がサクサクになり、より一層おいしくお召しあがり頂けます。',
    published_at: '2023-07-20T11:13:57+09:00',
    created_at: '2023-07-03T10:42:48+09:00',
    vendor: '食＋（ショクタス）公式オンラインショップ',
    type: '',
    tags: ['all', 'アレルゲン不使用', 'ベーカリー'],
    price: 95000,
    price_min: 95000,
    price_max: 95000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 44102948094206,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7180043',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: '玄米ブレッド プレーン',
        public_title: null,
        options: ['Default Title'],
        price: 95000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: '',
        quantity_rule: {
          min: 1,
          max: null,
          increment: 1,
        },
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 90300,
              },
            ],
            price: 90300,
            compare_at_price: 95000,
            per_delivery_price: 90300,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 90300,
              },
            ],
            price: 90300,
            compare_at_price: 95000,
            per_delivery_price: 90300,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 90300,
              },
            ],
            price: 90300,
            compare_at_price: 95000,
            per_delivery_price: 90300,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/BE-0028-001_01.png?v=1688348570',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/BE-0028-001_02.png?v=1688348570',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/BE-0028-001_03.png?v=1688348570',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/genmai-bread_code_001.png?v=1688609566',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/genmai-bread_code_002.png?v=1688609566',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/genmai-bread_code_003.png?v=1688609566',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/files/BE-0028-001_01.png?v=1688348570',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/be-0028-001',
    media: [
      {
        alt: null,
        id: 32502175596798,
        position: 1,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/BE-0028-001_01.png?v=1688348570',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/BE-0028-001_01.png?v=1688348570',
        width: 1500,
      },
      {
        alt: null,
        id: 32502175629566,
        position: 2,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/BE-0028-001_02.png?v=1688348570',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/BE-0028-001_02.png?v=1688348570',
        width: 1500,
      },
      {
        alt: null,
        id: 32502175662334,
        position: 3,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/BE-0028-001_03.png?v=1688348570',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/BE-0028-001_03.png?v=1688348570',
        width: 1500,
      },
      {
        alt: null,
        id: 32516131029246,
        position: 4,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/genmai-bread_code_001.png?v=1688609566',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/genmai-bread_code_001.png?v=1688609566',
        width: 1500,
      },
      {
        alt: null,
        id: 32516131062014,
        position: 5,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/genmai-bread_code_002.png?v=1688609566',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/genmai-bread_code_002.png?v=1688609566',
        width: 1500,
      },
      {
        alt: null,
        id: 32516131094782,
        position: 6,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/genmai-bread_code_003.png?v=1688609566',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/genmai-bread_code_003.png?v=1688609566',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回ご注文プラン', '2週に1回ご注文プラン', '4週に1回ご注文プラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回ご注文プラン',
            description: '週1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回ご注文プラン',
            description: '2週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回ご注文プラン',
            description: '4週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '6個',
      },
      {
        title: '原材料',
        content:
          '玄米（熊本県産）、砂糖、植物油脂、イースト、食塩、オリゴ糖、米粉／増粘剤（増粘多糖類、ＨＰＭＣ）、加工デンプン、トレハロース',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content: 'エネルギー 923kcal、たんぱく質 10.9g、脂質 26.5g、炭水化物 160.1g、食塩相当量 3.2g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: false,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: false,
          },
          {
            title: '乳成分',
            content: false,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: false,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: false,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: false,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: false,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },

      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約60mm×約60mm×約60mm / 約52g',
      },
      {
        title: 'お召し上がり方法',
        content:
          '袋から出し、お皿に並べてラップをかけ室温（約25℃）で約2時間解凍してください。解凍した玄米ブレッドを1～2分程度トーストするとより一層おいしくお召し上がりいただけます。',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上※パッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '',
    allergy_caution: '',
  },
  //玄米ブレッド ブルーベリー
  {
    id: 8082964578558,
    title: '玄米ブレッド ブルーベリー',
    handle: 'be-0030-001',
    description:
      'アレルギー特定原材料等28品目不使用。白米と比べて栄養価の高い玄米（熊本県産）を丸ごとペーストにして使用し、丁寧に焼き上げたキューブ形状のパンです。ふんわり、しっとり、もっちりとした食感に加え、玄米のほのかな甘みにブルーベリーの芳醇な香りと甘みを融合させ、フルーティで風味豊かな味わいに仕上げたフレーバータイプです。トースターで温めると、玄米の特性上、外側の生地がサクサクになり、より一層おいしくお召しあがり頂けます。',
    published_at: '2023-07-20T11:14:05+09:00',
    created_at: '2023-07-03T10:46:58+09:00',
    vendor: '食＋（ショクタス）公式オンラインショップ',
    type: '',
    tags: ['all', 'アレルゲン不使用', 'ベーカリー'],
    price: 95000,
    price_min: 95000,
    price_max: 95000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 44102948192510,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7180045',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: '玄米ブレッド ブルーベリー',
        public_title: null,
        options: ['Default Title'],
        price: 95000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: '',
        quantity_rule: {
          min: 1,
          max: null,
          increment: 1,
        },
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 90300,
              },
            ],
            price: 90300,
            compare_at_price: 95000,
            per_delivery_price: 90300,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 90300,
              },
            ],
            price: 90300,
            compare_at_price: 95000,
            per_delivery_price: 90300,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 90300,
              },
            ],
            price: 90300,
            compare_at_price: 95000,
            per_delivery_price: 90300,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/BE-0030-001_01.png?v=1688348819',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/BE-0030-001_02.png?v=1688348819',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/BE-0030-001_03.png?v=1688348820',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/genmai-bread_code_004.png?v=1688609594',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/genmai-bread_code_005.png?v=1688609595',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/genmai-bread_code_006.png?v=1688609594',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/genmai-bread_code_007.png?v=1688609595',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/files/BE-0030-001_01.png?v=1688348819',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/be-0030-001',
    media: [
      {
        alt: null,
        id: 32502185033982,
        position: 1,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/BE-0030-001_01.png?v=1688348819',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/BE-0030-001_01.png?v=1688348819',
        width: 1500,
      },
      {
        alt: null,
        id: 32502185066750,
        position: 2,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/BE-0030-001_02.png?v=1688348819',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/BE-0030-001_02.png?v=1688348819',
        width: 1500,
      },
      {
        alt: null,
        id: 32502185099518,
        position: 3,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/BE-0030-001_03.png?v=1688348820',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/BE-0030-001_03.png?v=1688348820',
        width: 1500,
      },
      {
        alt: null,
        id: 32516131913982,
        position: 4,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/genmai-bread_code_004.png?v=1688609594',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/genmai-bread_code_004.png?v=1688609594',
        width: 1500,
      },
      {
        alt: null,
        id: 32516131946750,
        position: 5,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/genmai-bread_code_005.png?v=1688609595',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/genmai-bread_code_005.png?v=1688609595',
        width: 1500,
      },
      {
        alt: null,
        id: 32516131979518,
        position: 6,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/genmai-bread_code_006.png?v=1688609594',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/genmai-bread_code_006.png?v=1688609594',
        width: 1500,
      },
      {
        alt: null,
        id: 32516132012286,
        position: 7,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/genmai-bread_code_007.png?v=1688609595',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/genmai-bread_code_007.png?v=1688609595',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回ご注文プラン', '2週に1回ご注文プラン', '4週に1回ご注文プラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回ご注文プラン',
            description: '週1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回ご注文プラン',
            description: '2週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回ご注文プラン',
            description: '4週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '6個',
      },
      {
        title: '原材料',
        content:
          '玄米（熊本県産）、砂糖、植物油脂、ドライブルーベリー、イースト、食塩、オリゴ糖、洋酒、米粉／増粘剤（増粘多糖類、ＨＰＭＣ）、加工デンプン、トレハロース、香料',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content: 'エネルギー 978kcal、たんぱく質 11.4g、脂質 25.5g、炭水化物 175.7g、食塩相当量 3.1g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: false,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: false,
          },
          {
            title: '乳成分',
            content: false,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: false,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: false,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: false,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: false,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },

      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約60mm×約60mm×約60mm / 約56g',
      },
      {
        title: 'お召し上がり方法',
        content:
          '袋から出し、お皿に並べてラップをかけ室温（約25℃）で約2時間解凍してください。解凍した玄米ブレッドを1～2分程度トーストするとより一層おいしくお召し上がりいただけます。',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上※パッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '',
    allergy_caution: '',
  },
  //玄米ブレッド あまくさ晩柑（ばんかん）
  {
    id: 8082964545790,
    title: '玄米ブレッド あまくさ晩柑（ばんかん）',
    handle: 'be-0029-001',
    description:
      'アレルギー特定原材料等28品目不使用。白米と比べて栄養価の高い玄米（熊本県産）を丸ごとペーストにして使用し、丁寧に焼き上げたキューブ形状のパンです。ふんわり、しっとり、もっちりとした食感に加え、玄米のほのかな甘みにあまくさ晩柑（ばんかん）のさわやかな酸味と香りが調和し、すっきりとした上品な味わいをお楽しみいただけるフレーバータイプです。トースターで温めると、玄米の特性上、外側の生地がサクサクになり、より一層おいしくお召しあがり頂けます。',
    published_at: '2023-07-20T11:14:02+09:00',
    created_at: '2023-07-03T10:45:45+09:00',
    vendor: '食＋（ショクタス）公式オンラインショップ',
    type: '',
    tags: ['all', 'アレルゲン不使用', 'ベーカリー'],
    price: 95000,
    price_min: 95000,
    price_max: 95000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 44102948126974,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7180044',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: '玄米ブレッド あまくさ晩柑（ばんかん）',
        public_title: null,
        options: ['Default Title'],
        price: 95000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: '',
        quantity_rule: {
          min: 1,
          max: null,
          increment: 1,
        },
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 90300,
              },
            ],
            price: 90300,
            compare_at_price: 95000,
            per_delivery_price: 90300,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 90300,
              },
            ],
            price: 90300,
            compare_at_price: 95000,
            per_delivery_price: 90300,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 90300,
              },
            ],
            price: 90300,
            compare_at_price: 95000,
            per_delivery_price: 90300,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/BE-0029-001_01.png?v=1688348747',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/BE-0029-001_02.png?v=1688348747',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/BE-0029-001_03.png?v=1688348747',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/genmai-bread_code_008.png?v=1688609580',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/genmai-bread_code_009.png?v=1688609580',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/genmai-bread_code_010.png?v=1688609581',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/genmai-bread_code_011.png?v=1688609581',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/files/BE-0029-001_01.png?v=1688348747',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/be-0029-001',
    media: [
      {
        alt: null,
        id: 32502182510846,
        position: 1,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/BE-0029-001_01.png?v=1688348747',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/BE-0029-001_01.png?v=1688348747',
        width: 1500,
      },
      {
        alt: null,
        id: 32502182543614,
        position: 2,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/BE-0029-001_02.png?v=1688348747',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/BE-0029-001_02.png?v=1688348747',
        width: 1500,
      },
      {
        alt: null,
        id: 32502182576382,
        position: 3,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/BE-0029-001_03.png?v=1688348747',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/BE-0029-001_03.png?v=1688348747',
        width: 1500,
      },
      {
        alt: null,
        id: 32516131356926,
        position: 4,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/genmai-bread_code_008.png?v=1688609580',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/genmai-bread_code_008.png?v=1688609580',
        width: 1500,
      },
      {
        alt: null,
        id: 32516131389694,
        position: 5,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/genmai-bread_code_009.png?v=1688609580',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/genmai-bread_code_009.png?v=1688609580',
        width: 1500,
      },
      {
        alt: null,
        id: 32516131422462,
        position: 6,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/genmai-bread_code_010.png?v=1688609581',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/genmai-bread_code_010.png?v=1688609581',
        width: 1500,
      },
      {
        alt: null,
        id: 32516131455230,
        position: 7,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/genmai-bread_code_011.png?v=1688609581',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/genmai-bread_code_011.png?v=1688609581',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回ご注文プラン', '2週に1回ご注文プラン', '4週に1回ご注文プラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回ご注文プラン',
            description: '週1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回ご注文プラン',
            description: '2週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回ご注文プラン',
            description: '4週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '6個',
      },
      {
        title: '原材料',
        content:
          '玄米（熊本県産）、砂糖、植物油脂、糖漬ばんかん果皮、イースト、食塩、オリゴ糖、米粉／増粘剤（増粘多糖類、ＨＰＭＣ）、加工デンプン、トレハロース、酸化防止剤（Ｖ．Ｃ）',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content: 'エネルギー 992kcal、たんぱく質 11.4g、脂質 26.9g、炭水化物 176.1g、食塩相当量 3.2g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: false,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: false,
          },
          {
            title: '乳成分',
            content: false,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: false,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: false,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: false,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: false,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },

      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約60mm×約60mm×約60mm / 約56g',
      },
      {
        title: 'お召し上がり方法',
        content:
          '袋から出し、お皿に並べてラップをかけ室温（約25℃）で約2時間解凍してください。解凍した玄米ブレッドを1～2分程度トーストするとより一層おいしくお召し上がりいただけます。',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上※パッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '',
    allergy_caution: '',
  },
  //豆乳のカップデザート アールグレイ
  {
    id: 8108041994494,
    title: '豆乳のカップデザート アールグレイ',
    handle: 'de-0021-001',
    description:
      '動物性原材料不使用。簡単便利なカップ入りデザート。豆乳原料にアールグレイの茶葉を混ぜ込んで作ったムースにアールグレイ風味のゼリー、クリームをトッピング。米粉とアーモンドで作ったクランブルが食感のアクセントになっています。冷凍庫から取り出して10分程度自然解凍したのちに、スプーンでお召しあがりください。',
    published_at: '2023-08-29T09:52:31+09:00',
    created_at: '2023-08-23T12:15:42+09:00',
    vendor: '食＋（ショクタス）公式オンラインショップ',
    type: 'カップデザート',
    tags: ['all', 'デザート', 'ビヨンドフリー', '動物性原材料不使用'],
    price: 49000,
    price_min: 49000,
    price_max: 49000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 44173380714750,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7180047',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: '豆乳のカップデザート アールグレイ',
        public_title: null,
        options: ['Default Title'],
        price: 49000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: 'de-0021-001',
        quantity_rule: {
          min: 1,
          max: null,
          increment: 1,
        },
        quantity_price_breaks: [],
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-10.png?v=1692760565',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-11.png?v=1692760563',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-12.png?v=1692760566',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-13.png?v=1692760564',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-3.png?v=1692760563',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-6.png?v=1692760565',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-9.png?v=1692760564',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-8.png?v=1692760566',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/what_s-plant-based_1140297d-9515-4841-8f92-6d740e4291f4.png?v=1692760563',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-10.png?v=1692760565',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/de-0021-001',
    media: [
      {
        alt: null,
        id: 32689042227454,
        position: 1,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-10.png?v=1692760565',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-10.png?v=1692760565',
        width: 1500,
      },
      {
        alt: null,
        id: 32689042260222,
        position: 2,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-11.png?v=1692760563',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-11.png?v=1692760563',
        width: 1500,
      },
      {
        alt: null,
        id: 32689042292990,
        position: 3,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-12.png?v=1692760566',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-12.png?v=1692760566',
        width: 1500,
      },
      {
        alt: null,
        id: 32689042325758,
        position: 4,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-13.png?v=1692760564',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-13.png?v=1692760564',
        width: 1500,
      },
      {
        alt: null,
        id: 32689042358526,
        position: 5,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-3.png?v=1692760563',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-3.png?v=1692760563',
        width: 1500,
      },
      {
        alt: null,
        id: 32689042391294,
        position: 6,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-6.png?v=1692760565',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-6.png?v=1692760565',
        width: 1500,
      },
      {
        alt: null,
        id: 32689042456830,
        position: 7,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-9.png?v=1692760564',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-9.png?v=1692760564',
        width: 1500,
      },
      {
        alt: null,
        id: 32689042489598,
        position: 8,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-8.png?v=1692760566',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-8.png?v=1692760566',
        width: 1500,
      },
      {
        alt: null,
        id: 32689042522366,
        position: 9,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/what_s-plant-based_1140297d-9515-4841-8f92-6d740e4291f4.png?v=1692760563',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/what_s-plant-based_1140297d-9515-4841-8f92-6d740e4291f4.png?v=1692760563',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回ご注文プラン', '2週に1回ご注文プラン', '4週に1回ご注文プラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回ご注文プラン',
            description: '週1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回ご注文プラン',
            description: '2週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回ご注文プラン',
            description: '4週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '1個',
      },
      {
        title: '原材料',
        content:
          '豆乳加工食品（植物油脂、豆乳クリーム、水あめ、でん粉、食塩）（国内製造）、砂糖、水あめ、米粉、ショートニング、豆乳フラワーペースト、アーモンドパウダー、紅茶ソース、寒天加工品、発酵調味料、アーモンド、紅茶／トレハロース、着色料（カラメル、紅花黄）、糊料（加工デンプン、カロブビーンガム）、乳化剤、pH調整剤、セルロース、香料、グリシン、酸化防止剤（V.E）、塩化Mg、保存料（ソルビン酸K）、ポリリン酸Na、（一部にアーモンド・大豆を含む）',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content: 'エネルギー 247kcal、たんぱく質 1.4g、脂質 18.5g、炭水化物 18.6g、食塩相当量 0.2g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: false,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: false,
          },
          {
            title: '乳成分',
            content: false,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: true,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: false,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: true,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: false,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },

      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約φ70㎜×約H50㎜/ 69g',
      },
      {
        title: 'お召し上がり方法',
        content: '袋のまま室温（約25℃）で約10分自然解凍してお召しあがりください。',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上※パッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '※本品製造工場では小麦を含む製品を生産しています。',
    allergy_caution: '',
  },
  //豆乳クリーム ロールケーキ アールグレイ
  {
    id: 8108041470206,
    title: '豆乳クリーム ロールケーキ アールグレイ',
    handle: 'de-0020-001',
    description:
      'アレルゲン「卵」・「乳」不使用。簡単便利なトレー入りデザート。しっとりとした食感のスポンジにアールグレイの茶葉を混ぜ込み、アールグレイ風味の豆乳ホイップクリームを合わせたロールケーキです。動物性原材料不使用でも、しっかり濃厚な味わいを実現しました。冷凍庫から取り出して10分程度自然解凍したのちに、スプーンやフォークでお召しあがりください。',
    published_at: '2023-08-29T09:52:35+09:00',
    created_at: '2023-08-23T12:15:17+09:00',
    vendor: '食＋（ショクタス）公式オンラインショップ',
    type: 'ロールケーキ',
    tags: ['all', 'アレルゲン不使用', 'デザート', 'ビヨンドフリー', '動物性原材料不使用', '卵・乳不使用'],
    price: 49000,
    price_min: 49000,
    price_max: 49000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 44173379600638,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7180048',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: '豆乳クリーム ロールケーキ アールグレイ',
        public_title: null,
        options: ['Default Title'],
        price: 49000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: 'de-0020-001',
        quantity_rule: {
          min: 1,
          max: null,
          increment: 1,
        },
        quantity_price_breaks: [],
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-1.png?v=1692760540',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-7.png?v=1692760540',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-8.png?v=1692760540',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-9.png?v=1692760538',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-2.png?v=1692760541',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-5.png?v=1692760541',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-7.png?v=1692760540',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-9_a6376a69-9110-4f46-9762-e30cf337283b.png?v=1692760539',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/what_s-plant-based_e6e07214-2c77-4139-af86-f9546d6183b9.png?v=1692760538',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-1.png?v=1692760540',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/de-0020-001',
    media: [
      {
        alt: null,
        id: 32689039048958,
        position: 1,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-1.png?v=1692760540',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-1.png?v=1692760540',
        width: 1500,
      },
      {
        alt: null,
        id: 32689039081726,
        position: 2,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-7.png?v=1692760540',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-7.png?v=1692760540',
        width: 1500,
      },
      {
        alt: null,
        id: 32689039114494,
        position: 3,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-8.png?v=1692760540',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-8.png?v=1692760540',
        width: 1500,
      },
      {
        alt: null,
        id: 32689039147262,
        position: 4,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-9.png?v=1692760538',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-9.png?v=1692760538',
        width: 1500,
      },
      {
        alt: null,
        id: 32689039180030,
        position: 5,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-2.png?v=1692760541',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-2.png?v=1692760541',
        width: 1500,
      },
      {
        alt: null,
        id: 32689039212798,
        position: 6,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-5.png?v=1692760541',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-5.png?v=1692760541',
        width: 1500,
      },
      {
        alt: null,
        id: 32689039245566,
        position: 7,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-7.png?v=1692760540',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-7.png?v=1692760540',
        width: 1500,
      },
      {
        alt: null,
        id: 32689039278334,
        position: 8,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-9_a6376a69-9110-4f46-9762-e30cf337283b.png?v=1692760539',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-9_a6376a69-9110-4f46-9762-e30cf337283b.png?v=1692760539',
        width: 1500,
      },
      {
        alt: null,
        id: 32689039311102,
        position: 9,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/what_s-plant-based_e6e07214-2c77-4139-af86-f9546d6183b9.png?v=1692760538',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/what_s-plant-based_e6e07214-2c77-4139-af86-f9546d6183b9.png?v=1692760538',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回ご注文プラン', '2週に1回ご注文プラン', '4週に1回ご注文プラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回ご注文プラン',
            description: '週1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回ご注文プラン',
            description: '2週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回ご注文プラン',
            description: '4週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '1個',
      },
      {
        title: '原材料',
        content:
          '豆乳加工食品（植物油脂、豆乳クリーム、水あめ、でん粉、食塩）（国内製造）、豆乳、砂糖、豆乳フラワーペースト、豆乳発酵食品、粉末調製豆乳、加工油脂、米粉、紅茶ソース、乾燥おから、紅茶、発酵調味料／加工デンプン、乳化剤、膨張剤、糊料（加工デンプン、増粘多糖類）、着色料（カラメル、紅花黄、カロチノイド、ウコン）、pH調整剤、グリシン、セルロース、香料、酸化防止剤（V.E）、塩化Mg、塩化マグネシウム含有物、保存料（ソルビン酸K）、ポリリン酸Na、（一部に大豆を含む）',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content: 'エネルギー 203kcal、たんぱく質 3.0g、脂質 11.8g、炭水化物 21.1g、食塩相当量 0.３g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: false,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: false,
          },
          {
            title: '乳成分',
            content: false,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: false,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: false,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: true,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: false,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },

      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約φ90㎜×約H25㎜/ 66g',
      },
      {
        title: 'お召し上がり方法',
        content: '袋のまま室温（約25℃）で約10分自然解凍してお召しあがりください。',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上※パッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '※本品製造工場では小麦・卵・乳成分を含む製品を生産しています。',
    allergy_caution: '※本品製造工場では小麦・卵・乳成分を含む製品を生産しています。',
  },
  //脂質50%オフ 山芋と米粉でつくったお好み焼
  {
    id: 8123627110654,
    title: '脂質50%オフ 山芋と米粉でつくったお好み焼',
    handle: 'sn-0001-001',
    description:
      '小麦粉の代わりに国産米粉と山芋を使用し、ふわとろ食感に仕上げたお好み焼です。1日の摂取目安量の約1/3量となる国産野菜（キャベツ、山芋、ネギ）を配合（※）し、当社「ごっつ旨いお好み焼」と比較して100ｇ当たりの脂質をおよそ50％カットしました。紙皿付きで簡単調理。添付に特製醤油だれ、かつお節付き。※1日の野菜摂取目安量350gに対し、1/3を使用しています。生野菜換算（仕込み時）厚生労働省「健康日本21」より',
    published_at: '2023-09-26T22:28:24+09:00',
    created_at: '2023-09-26T09:25:11+09:00',
    vendor: '食＋（ショクタス）公式オンラインショップ',
    type: '',
    tags: ['all', 'ビヨンドフリー', '粉もの', '糖質 / 塩分 / 脂質カット', '脂質カット'],
    price: 40000,
    price_min: 40000,
    price_max: 40000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 44224701006078,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7180049',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: '脂質50%オフ 山芋と米粉でつくったお好み焼',
        public_title: null,
        options: ['Default Title'],
        price: 40000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: null,
        quantity_rule: {
          min: 1,
          max: null,
          increment: 1,
        },
        quantity_price_breaks: [],
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 38000,
              },
            ],
            price: 38000,
            compare_at_price: 40000,
            per_delivery_price: 38000,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 38000,
              },
            ],
            price: 38000,
            compare_at_price: 40000,
            per_delivery_price: 38000,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 38000,
              },
            ],
            price: 38000,
            compare_at_price: 40000,
            per_delivery_price: 38000,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-14.png?v=1695687943',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-15.png?v=1695687945',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-16.png?v=1695687945',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-17.png?v=1695687943',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-4.png?v=1695687944',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-14.png?v=1695687943',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/sn-0001-001',
    media: [
      {
        alt: null,
        id: 32822788456702,
        position: 1,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-14.png?v=1695687943',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-14.png?v=1695687943',
        width: 1500,
      },
      {
        alt: null,
        id: 32822788489470,
        position: 2,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-15.png?v=1695687945',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-15.png?v=1695687945',
        width: 1500,
      },
      {
        alt: null,
        id: 32822788522238,
        position: 3,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-16.png?v=1695687945',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-16.png?v=1695687945',
        width: 1500,
      },
      {
        alt: null,
        id: 32822788555006,
        position: 4,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-17.png?v=1695687943',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-17.png?v=1695687943',
        width: 1500,
      },
      {
        alt: null,
        id: 32822788587774,
        position: 5,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-4.png?v=1695687944',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-4.png?v=1695687944',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回ご注文プラン', '2週に1回ご注文プラン', '4週に1回ご注文プラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回ご注文プラン',
            description: '週1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回ご注文プラン',
            description: '2週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回ご注文プラン',
            description: '4週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '255グラム',
      },
      {
        title: '原材料',
        content:
          '【お好み焼】野菜〔キャベツ（国産）、やまいも、ねぎ〕、米粉、いか、全卵粉、牛脂、かつおエキス調味料、食塩、砂糖、魚粉、しょうゆ／増粘剤（加工デンプン、キサンタンガム）、トレハロース、調味料（アミノ酸等）、酸味料、（一部に小麦・卵・いか・牛肉・さば・大豆・やまいもを含む）<br>【タレ】しょうゆ、砂糖混合ぶどう糖果糖液糖、たん白加水分解物、かつおだし、レモン果汁、砂糖、かつお風味調味料、醸造酢、貝エキス、食塩、発酵調味料、酵母エキス／酒精、増粘剤（キサンタンガム）、（一部にかに・小麦・大豆・鶏肉を含む）【かつお削りぶし】かつおぶし',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content: 'エネルギー 267kcal、たんぱく質 9.9g、脂質 7.7g、炭水化物 39.5g、食塩相当量 2.7g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品衛生法に定められた表示義務のある8品目と、表示が推奨されている20品目を合わせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: true,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: true,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: true,
          },
          {
            title: '乳成分',
            content: false,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: false,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: true,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: true,
          },
          {
            title: 'ごま',
            content: false,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: true,
          },
          {
            title: '大豆',
            content: true,
          },
          {
            title: '鶏肉',
            content: true,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: true,
          },
          {
            title: 'りんご',
            content: false,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },

      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約230㎜×約185㎜×約25㎜ / 255g',
      },
      {
        title: 'お召し上がり方法',
        content:
          '【電子レンジ専用】※オート調理不可<br>①お好み焼と添付品を取り出し、添付の醤油だれは小袋のまま流水またはお湯で解凍しておきます。<br>②紙皿に凍ったままのお好み焼だけをのせ、ラップをかけずに電子レンジで温めます。<br><500W>：約7分10秒<br><600W>：約6分40秒<br>③やけどに注意して取り出し、解凍しておいた醤油だれ、かつお節をかけてお召しあがりください。<br>添付のかつお節は魚を原料としているため、まれに骨や皮が入る場合があります。<br><br>※袋ごと電子レンジに入れないでください。<br>※調理直後は紙皿が熱くなっていますので、ご注意ください。<br>※破裂することがありますので、絶対に醤油だれは電子レンジで温めないでください。<br>※調理時間は商品の温度や電子レンジの機種により多少異なります。<br>※調理後も冷たい場合は追加で10秒ずつ温めてください。',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上※賞味期限はパッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。<br>※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '',
    allergy_caution: '',
  },
  //あずきロール（2個入）
  {
    id: 8148858601726,
    title: 'あずきロール（2個入り）',
    handle: 'be-0031-001',
    description:
      '中種製法で仕込んだ生地に北海道産小豆のかのこ豆を加え、低温でじっくり焼き上げました。ふんわりとした食感と小豆のほんのりした甘さでやさしい味わいに仕上げたあずきロールです。動物性原材料不使用の商品です。',
    published_at: '2023-10-31T10:16:13+09:00',
    created_at: '2023-10-23T10:39:48+09:00',
    vendor: '食＋（ショクタス）公式オンラインショップ',
    type: '',
    tags: ['all', 'ビヨンドフリー', 'ベーカリー', '動物性原材料不使用'],
    price: 33000,
    price_min: 33000,
    price_max: 33000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 44307843186942,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7180050',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: 'あずきロール（2個入り）',
        public_title: null,
        options: ['Default Title'],
        price: 33000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: null,
        quantity_rule: {
          min: 1,
          max: null,
          increment: 1,
        },
        quantity_price_breaks: [],
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 31400,
              },
            ],
            price: 31400,
            compare_at_price: 33000,
            per_delivery_price: 31400,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 31400,
              },
            ],
            price: 31400,
            compare_at_price: 33000,
            per_delivery_price: 31400,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 31400,
              },
            ],
            price: 31400,
            compare_at_price: 33000,
            per_delivery_price: 31400,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-1.png?v=1698025206',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-3.png?v=1698025203',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-4.png?v=1698025203',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-5.png?v=1698025205',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-1_ae7459ce-1c88-4f34-b22f-8f2e5db614c2.png?v=1698025205',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/what_s-plant-based_0ce54708-feb9-4341-a5ff-2ae3db31a7e2.png?v=1698025203',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-1.png?v=1698025206',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/be-0031-001',
    media: [
      {
        alt: null,
        id: 32938905174270,
        position: 1,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-1.png?v=1698025206',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-1.png?v=1698025206',
        width: 1500,
      },
      {
        alt: null,
        id: 32938905207038,
        position: 2,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-3.png?v=1698025203',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-3.png?v=1698025203',
        width: 1500,
      },
      {
        alt: null,
        id: 32938905239806,
        position: 3,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-4.png?v=1698025203',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-4.png?v=1698025203',
        width: 1500,
      },
      {
        alt: null,
        id: 32938905272574,
        position: 4,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-5.png?v=1698025205',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500-5.png?v=1698025205',
        width: 1500,
      },
      {
        alt: null,
        id: 32938905305342,
        position: 5,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-1_ae7459ce-1c88-4f34-b22f-8f2e5db614c2.png?v=1698025205',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/1500x1500_-1_ae7459ce-1c88-4f34-b22f-8f2e5db614c2.png?v=1698025205',
        width: 1500,
      },
      {
        alt: null,
        id: 32938905338110,
        position: 6,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/what_s-plant-based_0ce54708-feb9-4341-a5ff-2ae3db31a7e2.png?v=1698025203',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/what_s-plant-based_0ce54708-feb9-4341-a5ff-2ae3db31a7e2.png?v=1698025203',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回ご注文プラン', '2週に1回ご注文プラン', '4週に1回ご注文プラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回ご注文プラン',
            description: '週1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回ご注文プラン',
            description: '2週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回ご注文プラン',
            description: '4週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '２個',
      },
      {
        title: '原材料',
        content:
          '小麦粉（国内製造）、かのこ豆（砂糖、あずき、還元水あめ）、ショートニング、砂糖、イースト、食塩／乳化剤、香料、ビタミンC、（一部に小麦を含む）',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content: 'エネルギー 169kcal、たんぱく質 4.3g、脂質 5.6g、炭水化物 25.3g、食塩相当量 0.5g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品衛生法に定められた表示義務のある8品目と、表示が推奨されている20品目を合わせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: true,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: false,
          },
          {
            title: '乳成分',
            content: false,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: false,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: false,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: false,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: false,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },
      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約230㎜×約185㎜×約25㎜ / 255g',
      },
      {
        title: 'お召し上がり方法',
        content: '袋のまま室温（約25℃）で約３時間解凍してください。',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上※賞味期限はパッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。<br>※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '※本品製造工場では卵・乳成分・ごまを含む製品を生産しています。',
    allergy_caution: '※本品製造工場では卵・乳成分・ごまを含む製品を生産しています。',
  },
  //米粉麺でつくった彩り野菜まぜそば
  {
    id: 8210650759422,
    title: '米粉麺でつくった彩り野菜まぜそば',
    handle: 'ud-0006-001',
    description:
      '米粉麺でつくったピリ辛仕立ての野菜まぜそばです。動物性原材料不使用で仕上げています。充填しているタレを、もちもちの米粉麺と5種の具材に絡めてお召し上がりください。簡単便利なトレー入り。',
    published_at: '2023-12-12T10:17:17+09:00',
    created_at: '2023-12-11T13:41:48+09:00',
    vendor: '食＋（ショクタス）公式オンラインショップ',
    type: '',
    tags: ['all', '動物性原材料不使用', '麺'],
    price: 49000,
    price_min: 49000,
    price_max: 49000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 44487607648510,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7180054',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: '米粉麺でつくった彩り野菜まぜそば',
        public_title: null,
        options: ['Default Title'],
        price: 49000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: '7180054',
        quantity_rule: {
          min: 1,
          max: null,
          increment: 1,
        },
        quantity_price_breaks: [],
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/5-1_1500x1500_1.png?v=1702269724',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/5-1_1500x1500_2.png?v=1702269725',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/5-1_1500x1500_7.png?v=1702269724',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/5-1_1500x1500_9.png?v=1702269724',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/5-1_1500x1500_13.png?v=1702269722',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/BEYONDFREE_5-2_1500x1500__3.png?v=1702269723',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/what_s-plant-based_6d7f6669-2096-4042-b0f2-38ced9008469.webp?v=1702269723',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/files/5-1_1500x1500_1.png?v=1702269724',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/ud-0006-001',
    media: [
      {
        alt: null,
        id: 33220822106366,
        position: 1,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/5-1_1500x1500_1.png?v=1702269724',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/5-1_1500x1500_1.png?v=1702269724',
        width: 1500,
      },
      {
        alt: null,
        id: 33220822139134,
        position: 2,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/5-1_1500x1500_2.png?v=1702269725',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/5-1_1500x1500_2.png?v=1702269725',
        width: 1500,
      },
      {
        alt: null,
        id: 33220822171902,
        position: 3,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/5-1_1500x1500_7.png?v=1702269724',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/5-1_1500x1500_7.png?v=1702269724',
        width: 1500,
      },
      {
        alt: null,
        id: 33220822204670,
        position: 4,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/5-1_1500x1500_9.png?v=1702269724',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/5-1_1500x1500_9.png?v=1702269724',
        width: 1500,
      },
      {
        alt: null,
        id: 33220822237438,
        position: 5,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/5-1_1500x1500_13.png?v=1702269722',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/5-1_1500x1500_13.png?v=1702269722',
        width: 1500,
      },
      {
        alt: null,
        id: 33220822270206,
        position: 6,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/BEYONDFREE_5-2_1500x1500__3.png?v=1702269723',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/BEYONDFREE_5-2_1500x1500__3.png?v=1702269723',
        width: 1500,
      },
      {
        alt: null,
        id: 33220822302974,
        position: 7,
        preview_image: {
          aspect_ratio: 1,
          height: 1100,
          width: 1100,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/what_s-plant-based_6d7f6669-2096-4042-b0f2-38ced9008469.webp?v=1702269723',
        },
        aspect_ratio: 1,
        height: 1100,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/what_s-plant-based_6d7f6669-2096-4042-b0f2-38ced9008469.webp?v=1702269723',
        width: 1100,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回ご注文プラン', '2週に1回ご注文プラン', '4週に1回ご注文プラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回ご注文プラン',
            description: '週1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回ご注文プラン',
            description: '2週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回ご注文プラン',
            description: '4週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '275グラム',
      },
      {
        title: '原材料',
        content:
          '米粉（国内製造）、野菜（もやし、ほうれんそう、にんじん）、植物油脂、しょうゆ加工品、食塩、香味油、砂糖、きくらげ、大豆たん白食品、しょうゆ、おろしにんにく、たん白加水分解物、オニオンエキスパウダー、粉末油脂、こんぶエキス、発酵調味料、醸造酢、酵母エキス、香辛料／加工デンプン、増粘剤（増粘多糖類、加工デンプン、アルギン酸Na、アルギン酸エステル）、調味料（アミノ酸等）、乳化剤、香辛料抽出物、酸味料、（一部に小麦・ごま・大豆を含む）',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content: 'エネルギー 399kcal、たんぱく質 6.6g、脂質 10.7g、炭水化物 69.0g、食塩相当量 4.0g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品衛生法に定められた表示義務のある8品目と、表示が推奨されている20品目を合わせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: true,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: false,
          },
          {
            title: '乳成分',
            content: false,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: false,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: true,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: true,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: false,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },
      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約190㎜×約150㎜×約40㎜ / 275g',
      },
      {
        title: 'お召し上がり方法',
        content:
          '【電子レンジ専用】<br>①外袋に２ｃｍほど切り込みを入れ、凍ったままの商品をラベルがある面を上にして、外袋のまま電子レンジで温めます。<br>＜500W＞約5分30秒<br>＜600W＞約4分30秒<br><br>②外袋からトレーを取り出し、よく混ぜてお召しあがりください。<br><br>※加熱後のトレーや中身は熱くなっておりますので、やけどにご注意ください。<br>※袋をあける際に蒸気が出ますので、ご注意ください。<br>※調理後も冷たい場合は、一度かき混ぜ、ラップを軽くかけてから追加で10秒ずつ温めてください。',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上 ※賞味期限はパッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。<br>※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '',
    allergy_caution:
      '※本品は原材料の一部に「小麦」やその他のアレルギー物質を含んでいます。お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
  },
  //米粉麺でつくった汁なし担々麺
  {
    id: 8210650562814,
    title: '米粉麺でつくった汁なし担々麺',
    handle: 'ud-0005-001',
    description:
      '米粉麺でつくった動物性原材料不使用の汁なし担々麺です。大豆ミートを使用したピリ辛の肉みそ風ソースが食欲をそそる一品。独自開発のもちもち食感の米粉麺を使用しています。簡単便利なトレー入り。',
    published_at: '2023-12-12T10:16:56+09:00',
    created_at: '2023-12-11T13:41:29+09:00',
    vendor: '食＋（ショクタス）公式オンラインショップ',
    type: '',
    tags: ['all', '動物性原材料不使用', '麺'],
    price: 49000,
    price_min: 49000,
    price_max: 49000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 44487597064446,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7180053',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: '米粉麺でつくった汁なし担々麺',
        public_title: null,
        options: ['Default Title'],
        price: 49000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: '7180053',
        quantity_rule: {
          min: 1,
          max: null,
          increment: 1,
        },
        quantity_price_breaks: [],
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/5-1_1500x1500_4.png?v=1702269707',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/5-1_1500x1500_5.png?v=1702269706',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/5-1_1500x1500_8.png?v=1702269704',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/5-1_1500x1500_11.png?v=1702269705',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/5-1_1500x1500_15.png?v=1702269706',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/BEYONDFREE_5-2_1500x1500__1.png?v=1702269705',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/what_s-plant-based_54c59eec-ab98-4544-8a16-a15a28243096.webp?v=1702269704',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/files/5-1_1500x1500_4.png?v=1702269707',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/ud-0005-001',
    media: [
      {
        alt: null,
        id: 33220821549310,
        position: 1,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/5-1_1500x1500_4.png?v=1702269707',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/5-1_1500x1500_4.png?v=1702269707',
        width: 1500,
      },
      {
        alt: null,
        id: 33220821582078,
        position: 2,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/5-1_1500x1500_5.png?v=1702269706',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/5-1_1500x1500_5.png?v=1702269706',
        width: 1500,
      },
      {
        alt: null,
        id: 33220821614846,
        position: 3,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/5-1_1500x1500_8.png?v=1702269704',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/5-1_1500x1500_8.png?v=1702269704',
        width: 1500,
      },
      {
        alt: null,
        id: 33220821647614,
        position: 4,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/5-1_1500x1500_11.png?v=1702269705',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/5-1_1500x1500_11.png?v=1702269705',
        width: 1500,
      },
      {
        alt: null,
        id: 33220821680382,
        position: 5,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/5-1_1500x1500_15.png?v=1702269706',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/5-1_1500x1500_15.png?v=1702269706',
        width: 1500,
      },
      {
        alt: null,
        id: 33220821713150,
        position: 6,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/BEYONDFREE_5-2_1500x1500__1.png?v=1702269705',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/BEYONDFREE_5-2_1500x1500__1.png?v=1702269705',
        width: 1500,
      },
      {
        alt: null,
        id: 33220821745918,
        position: 7,
        preview_image: {
          aspect_ratio: 1,
          height: 1100,
          width: 1100,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/what_s-plant-based_54c59eec-ab98-4544-8a16-a15a28243096.webp?v=1702269704',
        },
        aspect_ratio: 1,
        height: 1100,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/what_s-plant-based_54c59eec-ab98-4544-8a16-a15a28243096.webp?v=1702269704',
        width: 1100,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回ご注文プラン', '2週に1回ご注文プラン', '4週に1回ご注文プラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回ご注文プラン',
            description: '週1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回ご注文プラン',
            description: '2週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回ご注文プラン',
            description: '4週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '324グラム',
      },
      {
        title: '原材料',
        content:
          '米粉（国内製造）、粒状植物性たん白、ほうれんそう、ねりごま、芝麻醤、食塩、植物油脂、砂糖、きくらげ、甜麺醤、しょうゆ、香味油、おろししょうが、おろしにんにく、香辛料、豆板醤、粉末油脂、発酵調味料、酵母エキス／加工デンプン、増粘剤（増粘多糖類、アルギン酸Na、アルギン酸エステル、加工デンプン）、調味料（アミノ酸）、乳化剤、着色料（カロチノイド、カラメル、ココア）、酸味料、香辛料抽出物、（一部に小麦・ごま・大豆を含む）',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content: 'エネルギー 526kcal、たんぱく質 11.3g、脂質 21.1g、炭水化物 72.6g、食塩相当量 4.4g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品衛生法に定められた表示義務のある8品目と、表示が推奨されている20品目を合わせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: true,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: false,
          },
          {
            title: '乳成分',
            content: false,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: false,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: true,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: true,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: false,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },
      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約190㎜×約150㎜×約40㎜/ 324g',
      },
      {
        title: 'お召し上がり方法',
        content:
          '【電子レンジ専用】<br>①外袋に２ｃｍほど切り込みを入れ、凍ったままの商品をラベルがある面を上にして、外袋のまま電子レンジで温めます。<br>＜500W＞約6分30秒<br>＜600W＞約5分30秒<br><br>②外袋からトレーを取り出し、よく混ぜてお召しあがりください。<br><br>※加熱後のトレーや中身は熱くなっておりますので、やけどにご注意ください。<br>※袋をあける際に蒸気が出ますので、ご注意ください。<br>※調理後も冷たい場合は、一度かき混ぜ、ラップを軽くかけてから追加で10秒ずつ温めてください。',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上 ※賞味期限はパッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。<br>※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '',
    allergy_caution:
      '※本品は原材料の一部に「小麦」やその他のアレルギー物質を含んでいます。お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
  },
  //豆乳のカップデザート アップル
  {
    id: 8236182274302,
    title: '豆乳のカップデザート アップル',
    handle: 'de-0022-001',
    description:
      '動物性原材料不使用。簡単便利なカップ入りデザート。豆乳原料にりんご果汁を混ぜ込んで作ったムースにりんごのゼリー、クリーム、りんごダイス入りのソースをトッピングしました。米粉とアーモンドで作ったクランブルが食感のアクセントになっています。冷凍庫から取り出して10分程度自然解凍したのちに、スプーンでお召しあがりください。',
    published_at: '2024-01-23T10:17:46+09:00',
    created_at: '2024-01-17T10:22:53+09:00',
    vendor: '食＋（ショクタス）公式オンラインショップ',
    type: '',
    tags: ['all', 'デザート', 'ビヨンドフリー', '動物性原材料不使用'],
    price: 49000,
    price_min: 49000,
    price_max: 49000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 44581744050430,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7180052',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: '豆乳のカップデザート アップル',
        public_title: null,
        options: ['Default Title'],
        price: 49000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: '7180052',
        quantity_rule: {
          min: 1,
          max: null,
          increment: 1,
        },
        quantity_price_breaks: [],
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 46600,
              },
            ],
            price: 46600,
            compare_at_price: 49000,
            per_delivery_price: 46600,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/BEYONDFREE_5-3_1500x1500_1.png?v=1705454593',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/BEYONDFREE_5-3_1500x1500_2.png?v=1705454593',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/BEYONDFREE_5-3_1500x1500_3.png?v=1705454594',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/BEYONDFREE_5-3_1500x1500_8.png?v=1705454591',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/BEYONDFREE_5-3_1500x1500_9.png?v=1705454593',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/BEYONDFREE_5-2_1500x1500__5.png?v=1705454592',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/what_s-plant-based_86f2b99c-1a18-415c-adf0-d49cb6aaac02.webp?v=1705454591',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/files/BEYONDFREE_5-3_1500x1500_1.png?v=1705454593',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/de-0022-001',
    media: [
      {
        alt: null,
        id: 33407787303166,
        position: 1,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/BEYONDFREE_5-3_1500x1500_1.png?v=1705454593',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/BEYONDFREE_5-3_1500x1500_1.png?v=1705454593',
        width: 1500,
      },
      {
        alt: null,
        id: 33407787335934,
        position: 2,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/BEYONDFREE_5-3_1500x1500_2.png?v=1705454593',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/BEYONDFREE_5-3_1500x1500_2.png?v=1705454593',
        width: 1500,
      },
      {
        alt: null,
        id: 33407787401470,
        position: 3,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/BEYONDFREE_5-3_1500x1500_3.png?v=1705454594',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/BEYONDFREE_5-3_1500x1500_3.png?v=1705454594',
        width: 1500,
      },
      {
        alt: null,
        id: 33407787434238,
        position: 4,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/BEYONDFREE_5-3_1500x1500_8.png?v=1705454591',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/BEYONDFREE_5-3_1500x1500_8.png?v=1705454591',
        width: 1500,
      },
      {
        alt: null,
        id: 33407787467006,
        position: 5,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/BEYONDFREE_5-3_1500x1500_9.png?v=1705454593',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/BEYONDFREE_5-3_1500x1500_9.png?v=1705454593',
        width: 1500,
      },
      {
        alt: null,
        id: 33407787499774,
        position: 6,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/BEYONDFREE_5-2_1500x1500__5.png?v=1705454592',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/BEYONDFREE_5-2_1500x1500__5.png?v=1705454592',
        width: 1500,
      },
      {
        alt: null,
        id: 33407787532542,
        position: 7,
        preview_image: {
          aspect_ratio: 1,
          height: 1100,
          width: 1100,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/what_s-plant-based_86f2b99c-1a18-415c-adf0-d49cb6aaac02.webp?v=1705454591',
        },
        aspect_ratio: 1,
        height: 1100,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/what_s-plant-based_86f2b99c-1a18-415c-adf0-d49cb6aaac02.webp?v=1705454591',
        width: 1100,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回ご注文プラン', '2週に1回ご注文プラン', '4週に1回ご注文プラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回ご注文プラン',
            description: '週1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回ご注文プラン',
            description: '2週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回ご注文プラン',
            description: '4週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '1個',
      },
      {
        title: '原材料',
        content:
          '豆乳加工食品（植物油脂、豆乳クリーム、水あめ、でん粉、食塩）（国内製造）、りんご濃縮果汁、砂糖、豆乳発酵食品、りんごシロップ漬け（りんご、ぶどう糖果糖液糖、砂糖）、水あめ、米粉、ショートニング、アーモンドパウダー、でん粉分解物、寒天加工品、アーモンド、発酵調味料、シナモンパウダー／トレハロース、乳化剤、pH調整剤、糊料（加工デンプン、増粘多糖類）、セルロース、酸味料、グリシン、酸化防止剤（V.E、V.C）、塩化マグネシウム含有物、着色料（紅麹）、香料、乳酸Ca、塩化Mg、（一部にアーモンド・大豆・りんごを含む）',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content: 'エネルギー 244kcal、たんぱく質 1.6g、脂質 16.6g、炭水化物 22.1g、食塩相当量 0.1g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品衛生法に定められた表示義務のある8品目と、表示が推奨されている20品目を合わせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: false,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: false,
          },
          {
            title: '乳成分',
            content: false,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: true,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: false,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: true,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: true,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ表示のアレルギー物質の記載内容が異なる場合がございます。 お召し上がりの際は、必ずお持ちの商品の表示をご確認ください。',
      },
      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約70㎜×約70㎜×約50㎜/75 g',
      },
      {
        title: 'お召し上がり方法',
        content: '袋のまま室温（約25℃）で約10分自然解凍してお召しあがりください。',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上 ※賞味期限はパッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。<br>※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '※本品製造工場では小麦を含む製品を生産しています。',
    allergy_caution: '',
  },
  //セット商品
  {
    id: 8013096943870,
    title: '【定期便】 糖質30%オフ お皿がいらないうどんを楽しむセット',
    handle: 'se-0015-002',
    description:
      '糖質30％オフ明太クリームうどんとぶっかけ牛肉うどんの2種×各3個ずつを詰め合せた定期便専用セットです。おトクな定期便価格になっています。',
    published_at: '2023-05-15T11:43:59+09:00',
    created_at: '2023-03-16T21:42:35+09:00',
    vendor: '食＋（ショクタス）公式オンラインショップ',
    type: 'うどん',
    tags: ['うどん', '定期便', '糖質カット'],
    price: 293700,
    price_min: 293700,
    price_max: 293700,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 43934412964094,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: 'SE-0015-002',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: '【定期便】 糖質30%オフ お皿がいらないうどんを楽しむセット',
        public_title: null,
        options: ['Default Title'],
        price: 293700,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: 'SE-0015-002',
        quantity_rule: {
          min: 1,
          max: null,
          increment: 1,
        },
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 279000,
              },
            ],
            price: 279000,
            compare_at_price: 293700,
            per_delivery_price: 279000,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 279000,
              },
            ],
            price: 279000,
            compare_at_price: 293700,
            per_delivery_price: 279000,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 279000,
              },
            ],
            price: 279000,
            compare_at_price: 293700,
            per_delivery_price: 279000,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/64563_0307.jpg?v=1682062179',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/SE-0015-002.png?v=1681396215',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/SE-0011-005_82ec6d60-2adc-4d4a-bac4-6e0a8868dbe5.png?v=1681396215',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/SE-0011-006_5bc7226d-ba17-4460-8140-94ebb8b01199.png?v=1681396215',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/products/64563_0307.jpg?v=1682062179',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/se-0015-002',
    media: [
      {
        alt: null,
        id: 32200050278654,
        position: 1,
        preview_image: {
          aspect_ratio: 1,
          height: 2905,
          width: 2905,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/64563_0307.jpg?v=1682062179',
        },
        aspect_ratio: 1,
        height: 2905,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/64563_0307.jpg?v=1682062179',
        width: 2905,
      },
      {
        alt: null,
        id: 32200049885438,
        position: 2,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/SE-0015-002.png?v=1681396215',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/SE-0015-002.png?v=1681396215',
        width: 1500,
      },
      {
        alt: null,
        id: 32200050114814,
        position: 3,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/SE-0011-005_82ec6d60-2adc-4d4a-bac4-6e0a8868dbe5.png?v=1681396215',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/SE-0011-005_82ec6d60-2adc-4d4a-bac4-6e0a8868dbe5.png?v=1681396215',
        width: 1500,
      },
      {
        alt: null,
        id: 32200050082046,
        position: 4,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/SE-0011-006_5bc7226d-ba17-4460-8140-94ebb8b01199.png?v=1681396215',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/SE-0011-006_5bc7226d-ba17-4460-8140-94ebb8b01199.png?v=1681396215',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回ご注文プラン', '2週に1回ご注文プラン', '4週に1回ご注文プラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回ご注文プラン',
            description: '週1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回ご注文プラン',
            description: '2週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回ご注文プラン',
            description: '4週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: 'セット内容',
        content: '※栄養成分値・商品の大きさ/重量・お召し上がり方法等は各商品ごとの商品詳細ページをご覧ください。',
        set_products: [
          {
            title: '糖質30％オフ お皿がいらない明太クリームうどん',
            url: 'https://tablemark-stg.myshopify.com/products/ud-0002-001',
          },
          {
            title: '糖質30％オフ お皿がいらないぶっかけ牛肉うどん',
            url: 'https://tablemark-stg.myshopify.com/products/ud-0003-001',
          },
        ],
      },
      {
        title: '原材料',
        content: '',
        set_products: [
          {
            title: '糖質30％オフ お皿がいらない明太クリームうどん',
            url: 'https://tablemark-stg.myshopify.com/products/ud-0002-001',
            ingredients:
              'めん〔小麦粉（国内製造）、小麦たん白、食塩、還元水あめ、植物油脂／加工デンプン、増粘剤（アルギン酸Na、アルギン酸エステル）〕、牛乳、ほうれんそう、辛子めんたいこ、めんたいこ調味料、バター、クリーム、チキンエキス調味料、マーガリン、みそ、みりん、発酵調味料、粉糖、酵母エキス、たん白加水分解物／調味料（アミノ酸等）、増粘剤（加工デンプン、増粘多糖類）、トレハロース、乳化剤、着色料（紅麹、クチナシ、カロチノイド）、香料、発色剤（亜硝酸Na）、（一部に小麦・乳成分・大豆・鶏肉・ゼラチンを含む）',
          },
          {
            title: '糖質30％オフ お皿がいらないぶっかけ牛肉うどん',
            url: 'https://tablemark-stg.myshopify.com/products/ud-0003-001',
            ingredients:
              'めん〔小麦粉（国内製造）、小麦たん白、食塩、還元水あめ、植物油脂／加工デンプン、増粘剤（アルギン酸Na、アルギン酸エステル）〕、牛肉、ねぎ、砂糖、しょうゆ、たん白加水分解物、食塩、風味調味料、ゼラチン、煮干エキス、かつお節エキス、煮干、かつお節粉末、かつお節、しいたけエキス、こんぶ、発酵調味料、酵母エキス／調味料（アミノ酸等）、増粘剤（加工デンプン、キサンタンガム）、トレハロース、重曹、カラメル色素、くん液、（一部に小麦・乳成分・牛肉・大豆・ゼラチンを含む））',
          },
        ],
      },
    ],
    isSetItem: true,
    allergy_note: '',
    allergy_caution: '',
  },
  //【定期便】 プラントベース ライスバーガーを楽しむセット
  {
    id: 8035443540222,
    title: '【定期便】 プラントベース ライスバーガーを楽しむセット',
    handle: 'se-0014-002',
    description:
      'ライスバーガー 大豆ミート 焼肉味と生姜焼き味の2種×各3個ずつを詰め合せた定期便専用セットです。おトクな定期便価格になっています。',
    published_at: '2023-05-31T11:46:52+09:00',
    created_at: '2023-04-13T22:23:25+09:00',
    vendor: '食＋（ショクタス）公式オンラインショップ',
    type: '',
    tags: [],
    price: 240000,
    price_min: 240000,
    price_max: 240000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 43987646775550,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: 'SE-0014-002',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: '【定期便】 プラントベース ライスバーガーを楽しむセット',
        public_title: null,
        options: ['Default Title'],
        price: 240000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: 'SE-0014-002',
        quantity_rule: {
          min: 1,
          max: null,
          increment: 1,
        },
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 228000,
              },
            ],
            price: 228000,
            compare_at_price: 240000,
            per_delivery_price: 228000,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 228000,
              },
            ],
            price: 228000,
            compare_at_price: 240000,
            per_delivery_price: 228000,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 228000,
              },
            ],
            price: 228000,
            compare_at_price: 240000,
            per_delivery_price: 228000,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/e171f208-0466-4d4f-904b-f325590f4d55.png?v=1684460570',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/SE-0014-002.png?v=1684460570',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/SE-0005-004_fc1b41c6-3685-491c-8137-837282f3b749.png?v=1684460570',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/SE-0005-003_2603bf20-7015-40a4-8e0f-ea3ccbcd617a.png?v=1684460570',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/files/e171f208-0466-4d4f-904b-f325590f4d55.png?v=1684460570',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/se-0014-002',
    media: [
      {
        alt: null,
        id: 32320741409022,
        position: 1,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/e171f208-0466-4d4f-904b-f325590f4d55.png?v=1684460570',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/e171f208-0466-4d4f-904b-f325590f4d55.png?v=1684460570',
        width: 1500,
      },
      {
        alt: null,
        id: 32199973142782,
        position: 2,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/SE-0014-002.png?v=1684460570',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/SE-0014-002.png?v=1684460570',
        width: 1500,
      },
      {
        alt: null,
        id: 32199973077246,
        position: 3,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/SE-0005-004_fc1b41c6-3685-491c-8137-837282f3b749.png?v=1684460570',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/SE-0005-004_fc1b41c6-3685-491c-8137-837282f3b749.png?v=1684460570',
        width: 1500,
      },
      {
        alt: null,
        id: 32199973110014,
        position: 4,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/SE-0005-003_2603bf20-7015-40a4-8e0f-ea3ccbcd617a.png?v=1684460570',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/SE-0005-003_2603bf20-7015-40a4-8e0f-ea3ccbcd617a.png?v=1684460570',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回ご注文プラン', '2週に1回ご注文プラン', '4週に1回ご注文プラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回ご注文プラン',
            description: '週1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回ご注文プラン',
            description: '2週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回ご注文プラン',
            description: '4週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: 'セット内容',
        content: '※栄養成分値・商品の大きさ/重量・お召し上がり方法等は各商品ごとの商品詳細ページをご覧ください。',
        set_products: [
          {
            title: 'ライスバーガー 大豆ミート 焼肉味',
            url: 'https://shoku-tasu.jp/products/cr-0001-001',
          },
          {
            title: 'ライスバーガー 大豆ミート 生姜焼き味',
            url: 'https://shoku-tasu.jp/products/cr-0002-001',
          },
        ],
      },
      {
        title: '原材料',
        content: '',
        set_products: [
          {
            title: 'ライスバーガー 大豆ミート 焼肉味',
            url: 'https://shoku-tasu.jp/products/cr-0001-001',
            ingredients:
              'ライスプレート〔うるち米（国内産）、しょうゆ、植物油脂、みりん、でん粉、大豆多糖類、食塩〕、しょうゆ、たまねぎ、粒状植物性たん白、植物油脂、りんごピューレ、砂糖、発酵調味料、水あめ、みりん、おろしにんにく、コチジャン、たまねぎ加工品、おろししょうが、りんご濃縮果汁、食塩、豆板醤／増粘剤（加工デンプン、増粘多糖類）、調味料（アミノ酸等）、カラメル色素、トレハロース、酸味料、（一部に小麦・大豆・りんごを含む）',
          },
          {
            title: 'ライスバーガー 大豆ミート 生姜焼き味',
            url: 'https://shoku-tasu.jp/products/cr-0002-001',
            ingredients:
              'ライスプレート〔うるち米（国内産）、しょうゆ、植物油脂、みりん、でん粉、大豆多糖類、食塩〕、しょうゆ、たまねぎ、大豆たん白食品、植物油脂、砂糖、りんごピューレ、みりん、発酵調味料、おろししょうが、おろしにんにく、たまねぎ加工品、しょうが汁／増粘剤（加工デンプン、増粘多糖類）、トレハロース、調味料（アミノ酸）、カラメル色素、酸味料、（一部に小麦・大豆・りんごを含む）',
          },
        ],
      },
    ],
    isSetItem: true,
    allergy_note: '',
    allergy_caution: '',
  },
  //【定期便】 卵・乳不使用 豆乳クリーム ロールケーキを楽しむセット
  {
    id: 8035443802366,
    title: '【定期便】 卵・乳不使用 豆乳クリーム ロールケーキを楽しむセット',
    handle: 'se-0013-002',
    description:
      '豆乳クリーム ロールケーキ プレーンとチョコの2種×各3個ずつを詰め合せた定期便専用セットです。おトクな定期便価格になっています。',
    published_at: '2023-05-31T11:47:04+09:00',
    created_at: '2023-04-13T22:24:15+09:00',
    vendor: '食＋（ショクタス）公式オンラインショップ',
    type: '',
    tags: [],
    price: 293700,
    price_min: 293700,
    price_max: 293700,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 43987648053502,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: 'SE-0013-002',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: '【定期便】 卵・乳不使用 豆乳クリーム ロールケーキを楽しむセット',
        public_title: null,
        options: ['Default Title'],
        price: 293700,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: 'SE-0013-002',
        quantity_rule: {
          min: 1,
          max: null,
          increment: 1,
        },
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 279000,
              },
            ],
            price: 279000,
            compare_at_price: 293700,
            per_delivery_price: 279000,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 279000,
              },
            ],
            price: 279000,
            compare_at_price: 293700,
            per_delivery_price: 279000,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 279000,
              },
            ],
            price: 279000,
            compare_at_price: 293700,
            per_delivery_price: 279000,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/files/fc9831a6-7956-47a0-96bb-9f95cd11a987.png?v=1684460592',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/SE-0013-002.png?v=1684460592',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/01c82ab8d307053d1b320c2ab4f8dcdc.png?v=1684460592',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/255c84abee7f764e8070eafc6ad618d1.png?v=1684460592',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/files/fc9831a6-7956-47a0-96bb-9f95cd11a987.png?v=1684460592',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/se-0013-002',
    media: [
      {
        alt: null,
        id: 32320741867774,
        position: 1,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/fc9831a6-7956-47a0-96bb-9f95cd11a987.png?v=1684460592',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/files/fc9831a6-7956-47a0-96bb-9f95cd11a987.png?v=1684460592',
        width: 1500,
      },
      {
        alt: null,
        id: 32199976878334,
        position: 2,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/SE-0013-002.png?v=1684460592',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/SE-0013-002.png?v=1684460592',
        width: 1500,
      },
      {
        alt: null,
        id: 32199977369854,
        position: 3,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/01c82ab8d307053d1b320c2ab4f8dcdc.png?v=1684460592',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/01c82ab8d307053d1b320c2ab4f8dcdc.png?v=1684460592',
        width: 1500,
      },
      {
        alt: null,
        id: 32199977402622,
        position: 4,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/255c84abee7f764e8070eafc6ad618d1.png?v=1684460592',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/255c84abee7f764e8070eafc6ad618d1.png?v=1684460592',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回ご注文プラン', '2週に1回ご注文プラン', '4週に1回ご注文プラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回ご注文プラン',
            description: '週1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回ご注文プラン',
            description: '2週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回ご注文プラン',
            description: '4週に1回の定期注文プランです',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回ご注文プラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: 'セット内容',
        content: '※栄養成分値・商品の大きさ/重量・お召し上がり方法等は各商品ごとの商品詳細ページをご覧ください。',
        set_products: [
          {
            title: '豆乳クリーム ロールケーキ プレーン',
            url: 'https://shoku-tasu.jp/products/de-0015-001',
          },
          {
            title: '豆乳クリーム ロールケーキ チョコ',
            url: 'https://shoku-tasu.jp/products/de-0016-001',
          },
        ],
      },
      {
        title: '原材料',
        content: '',
        set_products: [
          {
            title: '豆乳クリーム ロールケーキ プレーン',
            url: 'https://shoku-tasu.jp/products/de-0015-001',
            ingredients:
              '豆乳加工食品（植物油脂、豆乳クリーム、水あめ、でん粉、食塩）（国内製造）、豆乳、砂糖、豆乳発酵食品、豆乳フラワーペースト、粉末調整豆乳、加工油脂、米粉、洋酒、乾燥おから、発酵調味料／加工デンプン、乳化剤、膨張剤、糊料（加工デンプン、増粘多糖類）、pH調整剤、グリシン、セルロース、塩化マグネシウム含有物、酸化防止剤（V.E）、塩化Mg、香料、保存料（ソルビン酸K）、ポリリン酸Na、着色料（カロチノイド、ウコン）、（一部に大豆を含む）',
          },
          {
            title: '豆乳クリーム ロールケーキ チョコ',
            url: 'https://shoku-tasu.jp/products/de-0016-001',
            ingredients:
              '豆乳加工食品（植物油脂、豆乳クリーム、水あめ、でん粉、食塩）（国内製造）、豆乳、豆乳フラワーペースト、カカオマス、砂糖、加工黒糖、水あめ、粉末調整豆乳、加工油脂、ココアパウダー、米粉、乾燥おから、発酵調味料、食塩／加工デンプン、トレハロース、乳化剤、糊料（加工デンプン、カロブビーンガム）、膨張剤、pH調整剤、セルロース、グリシン、酸化防止剤（V.E）、塩化Mg、保存料（ソルビン酸K）、ポリリン酸Na、香料、着色料（カロチノイド、ウコン）、（一部に大豆を含む）',
          },
        ],
      },
    ],
    isSetItem: true,
    allergy_note: '',
    allergy_caution: '',
  },
];
